import { writable } from "svelte/store";

const seeds = writable([
  {
    id: "-7357873331903616871",
    parentId: "243624406291698231",
    plantName: "Asparagus",
    seedName: "Jersey Supreme",
    seedDescription:
      "\nAnother variety from the Rutgers-bred Jersey line with excellent yield potential. High resistance to rust, and is highly tolerant to fusarium. We supply hardy, one-year-old crowns. Perennial. (1 Crown = 1 Unit).\n",
  },
  {
    id: "-2010482891080574839",
    parentId: "243624406291698231",
    plantName: "Asparagus",
    seedName: "Purple Passion",
    seedDescription:
      '\nSweeter and more tender than green varieties, with beautiful purple spears. A colorful option for raw eating in salads. Spears turn green when cooked, but still have excellent flavor. For best results, plant crowns at 6-8" in-row spacing to prevent overly thick spears. We supply hardy, one-year-old crowns. Perennial. (1 Crown = 1 Unit).\n',
  },
  {
    id: "2555516046956776636",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Apollo",
    seedDescription:
      "\nBred by the same breeder as Atlantis, Apollo is very similar but a couple of days earlier and with a slightly thinner stem. For maximum yield, cut main floret as soon as it appears. This results in a larger plant with a high quantity of side shoots. If main floret is allowed to mature, overall yield of side shoots will be reduced. If harvested 1-2 times per week, plants will bear well for approximately 4 weeks. Avg. 84,200 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "4760233993096908728",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Apollo",
    seedDescription:
      "\nBred by the same breeder as Atlantis, Apollo is very similar but a couple of days earlier and with a slightly thinner stem. For maximum yield, cut main floret as soon as it appears. This results in a larger plant with a high quantity of side shoots. If main floret is allowed to mature, overall yield of side shoots will be reduced. If harvested 1-2 times per week, plants will bear well for approximately 4 weeks. Avg. 84,200 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "-8718247211364557359",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Happy Rich",
    seedDescription:
      '\nUniform, vigorous, dark-green plants produce jumbo-size florets that resemble mini heads of broccoli, and have an excellent, sweet, broccoli flavor. Produces ample amounts of side shoots when first floret is pinched out and plants are spaced 12-18" apart. For a single crop harvest, space plants 6-8" apart. Avg. 5,500 seeds/oz. Packet: 250 seeds.\n',
  },
  {
    id: "4714195187403620245",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Happy Rich",
    seedDescription:
      '\nUniform, vigorous, dark-green plants produce jumbo-size florets that resemble mini heads of broccoli, and have an excellent, sweet, broccoli flavor. Produces ample amounts of side shoots when first floret is pinched out and plants are spaced 12-18" apart. For a single crop harvest, space plants 6-8" apart. Avg. 5,500 seeds/oz. Packet: 250 seeds.\n',
  },
  {
    id: "-8924958243002666610",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Spigariello Liscia",
    seedDescription:
      "\nThis variety is technically a leaf broccoli but it is grown like broccoli raab. Harvest individual leaves for continual harvest or whole plants for bunching. Sweet broccoli/kale flavor. Popular in southern Italy. Avg. 7,800 seeds/oz. Packet: 250 seeds.\n",
  },
  {
    id: "-6310259504739342659",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Spigariello Liscia",
    seedDescription:
      "\nThis variety is technically a leaf broccoli but it is grown like broccoli raab. Harvest individual leaves for continual harvest or whole plants for bunching. Sweet broccoli/kale flavor. Popular in southern Italy. Avg. 7,800 seeds/oz. Packet: 250 seeds.\n",
  },
  {
    id: "-2504772880938062065",
    parentId: "8966395072127027946",
    plantName: "Carrot",
    seedName: "Malbec",
    seedDescription:
      '\nMalbec produces smooth, uniform 10" long roots. Consistent, rich internal color for multiple end uses, including marketing as whole roots, sliced, or mini carrots. Pair with yellow, orange, white, and purple carrots for an eye-catching rainbow presentation. Avg. 16,900 seeds/lb. Packet: 250 seeds.\n',
  },
  {
    id: "2526364716744802731",
    parentId: "8966395072127027946",
    plantName: "Carrot",
    seedName: "Purple Elite",
    seedDescription:
      '\nThe rich purple skin contrasts nicely with its core and striations, both a beautiful yellow hue. Roots are 7-9" tapered. Tolerant to spring bolting. Avg. 18,000 seeds/lb. Packet: 250 seeds.\n',
  },
  {
    id: "4998778251709694886",
    parentId: "-8615932750481858489",
    plantName: "Celery",
    seedName: "Brilliant",
    seedDescription:
      "\nMedium-large, round, and relatively smooth roots with buff-colored skin. Interiors are white and flavorful, and resist pithiness and hollow heart. Avg. 11,200 seeds/oz. Packet: 250 seeds.\n",
  },
  {
    id: "953527633302990899",
    parentId: "-8615932750481858489",
    plantName: "Celery",
    seedName: "Conquistador",
    seedDescription:
      "\nConquistador is an early celery that produces full, upright heads packed with crisp, flavorful stalks. Performs well under heat and moisture stress and in soils of average fertility. Avg. 9,800 seeds/oz. Packet: 250 seeds.\n",
  },
  {
    id: "-168907594203649851",
    parentId: "-8615932750481858489",
    plantName: "Celery",
    seedName: "Mars",
    seedDescription:
      "\nLarge, uniform roots with big, healthy plants. Interiors stay firm, even when roots are large. Holds well in the field. Upright plant results in less splash from rain and, hence, less soilborne septoria blight as well as easier cultivation. Similar to Brilliant. Organically grown. Avg. 10,600 seeds/oz. Packet: 250 seeds.\n",
  },
  {
    id: "-3081660441387663417",
    parentId: "-8615932750481858489",
    plantName: "Celery",
    seedName: "Tango",
    seedDescription:
      "\nTango is as adaptable as Conquistador, but the flavor is better and the stalks are more tender and less fibrous. The plant is also a few inches taller. Tango performs well under less-than-ideal growing conditions such as heat or moisture stress. Organically grown. Avg. 11,300 seeds/oz. Packet: 250 seeds.\n",
  },
  {
    id: "3355049992578405355",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Champion",
    seedDescription:
      "\nSelected from the popular Vates variety for a more compact plant. Same rich, dark-green color with long, broad, wavy, tender leaves. Not as uniform or as high yielding as our hybrid varieties. Avg. 116,000 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "-5447231018859055902",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Champion",
    seedDescription:
      "\nSelected from the popular Vates variety for a more compact plant. Same rich, dark-green color with long, broad, wavy, tender leaves. Not as uniform or as high yielding as our hybrid varieties. Avg. 116,000 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "-6415056726613916130",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Flash",
    seedDescription:
      "\nVery slow to bolt. Flash offers repeated harvests of dark green, smooth leaves. Very high yielding. Avg. 85,200 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "-8602625819738018909",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Flash",
    seedDescription:
      "\nVery slow to bolt. Flash offers repeated harvests of dark green, smooth leaves. Very high yielding. Avg. 85,200 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "-6766105123535358081",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Tiger",
    seedDescription:
      "\nAs early and vigorous as Top Bunch, with the same medium-green, slightly-savoyed leaves. Avg. 82,800 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "6104244460010641303",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Tiger",
    seedDescription:
      "\nAs early and vigorous as Top Bunch, with the same medium-green, slightly-savoyed leaves. Avg. 82,800 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "6205669357497846628",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Top Bunch",
    seedDescription:
      "\nEarliest to harvest. Tall, productive plant produces medium green, slightly savoyed leaves. Our most attractive variety for fresh market sales. Avg. 60,400 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "2491870357577465918",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Top Bunch",
    seedDescription:
      "\nEarliest to harvest. Tall, productive plant produces medium green, slightly savoyed leaves. Our most attractive variety for fresh market sales. Avg. 60,400 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "9190372786251980937",
    parentId: "-4360259640222035586",
    plantName: "Corn",
    seedName: "Double Standard",
    seedDescription:
      "\nEarly maturing with strong germination in cool soil. We developed this hardy corn for northern home gardeners, especially seed-saving enthusiasts. It is based on a nice yellow corn called Burnell that was grown in Maine in the early 1900's and an early white heirloom from New York's St. Lawrence Valley. Nice-sized, avg. 7\", ears with 12-14 rows of yellow and white kernels, some ears with yellow kernels only. Unlike the seeds of hybrid bicolor corn, which are all yellow, these are yellow and white. If desired, you can have early, all-white corn simply by planting only white kernels. Excellent traditional corn taste. Vigorous 5' plants. (Untreated seeds only.) Organically grown. Avg. 2,100 seeds/lb. Packet: 150 seeds.\n",
  },
  {
    id: "1143117235919860403",
    parentId: "-4360259640222035586",
    plantName: "Corn",
    seedName: "Illusion",
    seedDescription:
      "\nExcellent cool soil vigor and tip fill. Strong disease resistance package. Dark-green husks and good snapping ease. Flavor much improved over Sugar Pearl, which it replaces. Untreated seeds also available. Avg. 2,300 seeds/lb. Packet: 150 seeds.\n",
  },
  {
    id: "5580141044613929540",
    parentId: "-4360259640222035586",
    plantName: "Corn",
    seedName: "Montauk",
    seedDescription:
      "\nThe 8\" long ears consist of 16-20 rows of small, fancy kernels. Superior sweet flavor. Sturdy 6Œ_' plants. Similar to Delectable but with better flavor and a more attractive ear. Easy to harvest. Widely adapted. Good cool soil vigor. Intermediate resistance to northern corn leaf blight and Stewart's wilt. Order 2761T (Treated) or 2761 (Untreated). Avg. 3,500 seeds/lb. Packet: 150 seeds.\n",
  },
  {
    id: "-7661375830477855315",
    parentId: "-4360259640222035586",
    plantName: "Corn",
    seedName: "Painted Mountain",
    seedDescription:
      "\nDeveloped for its hardiness, earliness, and colorful display in the mountains of Montana. Avg. 6-7\" multicolor ears for decorating, easy grinding, roasting, or use in hominy grits. Also makes a high-nutrition flour. Avg. 4' plants. Organically grown. Avg. 1,600 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "-8170618142607663181",
    parentId: "-4360259640222035586",
    plantName: "Corn",
    seedName: "Robust 997",
    seedDescription:
      "\n7-8\" ears with glossy, deep yellow kernels. A high percentage of kernels pop producing tender popcorn. 8-9' plants. Avg. 3,600 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "-3318839543541092095",
    parentId: "-4360259640222035586",
    plantName: "Corn",
    seedName: "Sugar Buns",
    seedDescription:
      "\nRemains tender for up to two weeks in the field for the longest harvest period of all early corn varieties. The 7\", 14-row ears have relatively narrow, deep kernels, making a nice package. 5-6', sturdy plants. Best at latitude 38° and higher. Intermediate resistance to northern corn leaf blight and Stewart's wilt. Avg. 2,600 seeds/lb. Packet: 150 seeds.\n",
  },
  {
    id: "-6991156402169317609",
    parentId: "-4360259640222035586",
    plantName: "Corn",
    seedName: "Trinity",
    seedDescription:
      "\nThe slender, 7 1/2-8\" long ears have fine-grained, tender-crisp, very sweet kernels in 14-16 rows. Strong germination for early, cool soil planting and great eating quality. Plants are 5' tall. Best at latitude 38° and higher. Intermediate resistance to northern corn leaf blight, common rust, and Stewart's wilt. Avg. 1,900 seeds/lb. Packet: 150 seeds.\n",
  },
  {
    id: "-7885828975719789373",
    parentId: "-6137866173690498356",
    plantName: "Eggplant",
    seedName: "Jaylo",
    seedDescription:
      "\nJaylo is high yielding and has the vigor to make it through a long season under greenhouse conditions. Beautiful, glossy black fruits have excellent flavor. A very versatile variety, fruits become firm at a small size, allowing it to be harvested at half-pound baby size or as a quarter-pound mini eggplant. Spineless plant with green calyx. Avg. 5,600 seeds/oz. Mini: 10 seeds. Packet: 25 seeds.\n",
  },
  {
    id: "2073828794099101423",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Kaleidoscope Mix",
    seedDescription:
      "\nFlower Sprouts�¬ are a cross between Brussels sprouts and kale which, unlike Brussels sprouts, remain open and resemble attractive, colorful flowers. They grow on tall, upright plants just like Brussels sprouts. The tender, mildly flavored sprouts have an excellent eating quality and are suitable for sales to high-end restaurants and specialty markets. They are excellent lightly steamed or saut�©ed. One marketing suggestion is to sell them in clam shells. Not quite as hardy to cold weather as Brussels sprouts or kale. This mix contains three varieties. Avg. 117,800 seeds/lb. Packet: 40 seeds.\n",
  },
  {
    id: "-2141121599054210214",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Kaleidoscope Mix",
    seedDescription:
      "\nFlower Sprouts�¬ are a cross between Brussels sprouts and kale which, unlike Brussels sprouts, remain open and resemble attractive, colorful flowers. They grow on tall, upright plants just like Brussels sprouts. The tender, mildly flavored sprouts have an excellent eating quality and are suitable for sales to high-end restaurants and specialty markets. They are excellent lightly steamed or saut�©ed. One marketing suggestion is to sell them in clam shells. Not quite as hardy to cold weather as Brussels sprouts or kale. This mix contains three varieties. Avg. 117,800 seeds/lb. Packet: 40 seeds.\n",
  },
  {
    id: "1750826818688062840",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Autumn Star",
    seedDescription:
      '\nKalettes�¬ are the product of years of breeding work that began with crosses between Brussels sprouts and kale. The open, flower-like florets are ready when approximately 2" in diameter. The three bicolor varieties we offer are specifically slated for different harvest slots. Autumn Star is our choice for early-season harvest. Avg. 121,400 seeds/lb. Packet: 25 seeds.\n',
  },
  {
    id: "6617910381833974163",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Autumn Star",
    seedDescription:
      '\nKalettes�¬ are the product of years of breeding work that began with crosses between Brussels sprouts and kale. The open, flower-like florets are ready when approximately 2" in diameter. The three bicolor varieties we offer are specifically slated for different harvest slots. Autumn Star is our choice for early-season harvest. Avg. 121,400 seeds/lb. Packet: 25 seeds.\n',
  },
  {
    id: "1375401699142385976",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Kalettes�¬ Collection",
    seedDescription:
      '\nKalettes�¬ are the product of years of breeding work that began with crosses between Brussels sprouts and kale. The open, flower-like florets are ready when approximately 2" in diameter. The three bicolor varieties we offer are specifically slated for different harvest slots. This collection includes one packet each of Autumn Star (for early-season harvest), Mistletoe (for midseason harvest), and Snowdrop (for late-season harvest). Plant all three for an extended harvest program.\n',
  },
  {
    id: "-1268887838724457515",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Kalettes�¬ Collection",
    seedDescription:
      '\nKalettes�¬ are the product of years of breeding work that began with crosses between Brussels sprouts and kale. The open, flower-like florets are ready when approximately 2" in diameter. The three bicolor varieties we offer are specifically slated for different harvest slots. This collection includes one packet each of Autumn Star (for early-season harvest), Mistletoe (for midseason harvest), and Snowdrop (for late-season harvest). Plant all three for an extended harvest program.\n',
  },
  {
    id: "1340122031132845540",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Mistletoe",
    seedDescription:
      '\nKalettes�¬ are the product of years of breeding work that began with crosses between Brussels sprouts and kale. The open, flower-like florets are ready when approximately 2" in diameter. The three bicolor varieties we offer are specifically slated for different harvest slots. Mistletoe is our choice for midseason harvest. Avg. 93,300 seeds/lb. Packet: 25 seeds.\n',
  },
  {
    id: "-7075192669826591262",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Mistletoe",
    seedDescription:
      '\nKalettes�¬ are the product of years of breeding work that began with crosses between Brussels sprouts and kale. The open, flower-like florets are ready when approximately 2" in diameter. The three bicolor varieties we offer are specifically slated for different harvest slots. Mistletoe is our choice for midseason harvest. Avg. 93,300 seeds/lb. Packet: 25 seeds.\n',
  },
  {
    id: "8199450188254515128",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Snowdrop",
    seedDescription:
      '\nKalettes�¬ are the product of years of breeding work that began with crosses between Brussels sprouts and kale. The open, flower-like florets are ready when approximately 2" in diameter. The three bicolor varieties we offer are specifically slated for different harvest slots. Snowdrop is our choice for a late-season harvest. Avg. 115,000 seeds/lb. Packet: 25 seeds.\n',
  },
  {
    id: "6256752210287585449",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Snowdrop",
    seedDescription:
      '\nKalettes�¬ are the product of years of breeding work that began with crosses between Brussels sprouts and kale. The open, flower-like florets are ready when approximately 2" in diameter. The three bicolor varieties we offer are specifically slated for different harvest slots. Snowdrop is our choice for a late-season harvest. Avg. 115,000 seeds/lb. Packet: 25 seeds.\n',
  },
  {
    id: "-5470783367269366588",
    parentId: "262644758805253510",
    plantName: "Lettuce",
    seedName: "Allstar Gourmet Lettuce Mix",
    seedDescription:
      "\nA specially designed blend based on two years of trial research to make your salad mix stand out from the crowd. Selected varieties yield darker reds and greens even under low-light conditions. Ruffled edges and unique leaf shapes provide loft, interesting texture, good shelf life, and fancy appearance. Includes green oakleaf, red oakleaf, green romaine, red romaine, lollo rossa, and red leaf lettuces. Varieties are subject to change depending upon availability. Avg. 31,450 seeds/oz. Packet: 1,000 seeds.\n",
  },
  {
    id: "-636652841337620047",
    parentId: "4069522599651715316",
    plantName: "Onion",
    seedName: "Deep Purple",
    seedDescription:
      "\nThe first red buncher that is highly colored at any temperature. For spring or summer sowing. Select organic or conventional seeds. Organically grown. Avg. 112,200 seeds/lb. Packet: 500 seeds.\n",
  },
  {
    id: "-7406313775426276722",
    parentId: "4069522599651715316",
    plantName: "Onion",
    seedName: "Gold Coin",
    seedDescription:
      '\nMatures to a small-medium, yellow cipollini onion, avg. 1 1/2-3" diam. x 3/4-1" depth. Pungent, but deliciously sweet when cooked. For bunching or braiding. Stores well. Recommended for latitudes 38-60°; necks may be too thick at lower latitudes. Avg. 130,300 seeds/lb. Packet: 1,000 seeds.\n',
  },
  {
    id: "-8287679323528921806",
    parentId: "4069522599651715316",
    plantName: "Onion",
    seedName: "Pompeii",
    seedDescription:
      "\nShort-day onion for growing in long-day areas to produce mini or pearl onions. Shape, size, and color are all very uniform. Seeding rate can be adjusted to get onions of desired size, or thin after seedlings are established. Best at 40Œ_ latitude and higher. Compared to Eclipse, Pompeii is a few days later to mature, with slightly smaller bulbs. Avg. 122,200 seeds/lb. Packet: 1,000 seeds.\n",
  },
  {
    id: "-6602190261498472225",
    parentId: "4069522599651715316",
    plantName: "Onion",
    seedName: "Yankee",
    seedDescription:
      "\nMedium-large globe-shaped bulbs with good skins and healthy tops. Strong root system tolerates some pink root. Stores approx. 6 months. Avg. 18,000 seeds/lb.\n",
  },
  {
    id: "-2440845273833018099",
    parentId: "5979176350229771391",
    plantName: "Parsnip",
    seedName: "Albion",
    seedDescription:
      "\nLong, tapered roots are noticeably whiter and slower to discolor than Javelin. While attractive, it is important to note that whiter varieties tend to have less disease resistance. Also available with NOP-approved pelleting. Avg. 123,100 seeds/lb. Packet: 350 seeds.\n",
  },
  {
    id: "-1532028106997530200",
    parentId: "5979176350229771391",
    plantName: "Parsnip",
    seedName: "Javelin",
    seedDescription:
      "\nSlim, smooth, tapered roots. Like Lancer but with added vigor, making it earlier and larger. Same high quality and field resistance to canker. Avg. 5,400 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "-6457625120826296422",
    parentId: "5979176350229771391",
    plantName: "Parsnip",
    seedName: "Lancer",
    seedDescription:
      "\nLong, slender, smooth roots. Improved uniformity and with better field resistance to canker than the old Harris Model. Very sweet. Avg. 116,600 seeds/lb. Packet: 350 seeds.\n",
  },
  {
    id: "-930848190777412198",
    parentId: "5979176350229771391",
    plantName: "Parsnip",
    seedName: "White Spear",
    seedDescription:
      "\nVery white roots. Classic parsnip shape with a deep crown set, wide-rounded shoulders, and quick tapering roots. Compared to Lancer, which it replaces, White Spear has more uniform root shape and plant vigor. Avg. 120,000 seeds/lb. Packet: 350 seeds.\n",
  },
  {
    id: "559700469281501782",
    parentId: "-1452327664920181626",
    plantName: "Pepper",
    seedName: "Milena",
    seedDescription:
      "\nMilena's resilient plants perform well in both low-tech greenhouses and unheated tunnels. The medium-large to large fruits are deep orange and have very good flavor. Similar to Sympathy, which it replaces. High resistance to potato virus Y, tobacco etch virus, tobamovirus races 0-3, and tomato spotted wilt virus. Avg. 60,000 seeds/lb. Mini: 10 seeds. Packet: 25 seeds.\n",
  },
  {
    id: "5848418558673810731",
    parentId: "-1452327664920181626",
    plantName: "Pepper",
    seedName: "Sprinter",
    seedDescription:
      "\nSprinter has a vegetative plant that keeps it strong through adverse weather conditions, whether too hot or too cold. Benefits from at least some heat, but will produce high yields of beautiful, large, dark-red fruits through a variety of conditions. Excellent flavor. High resistance to tobamovirus races 0-3. Avg. 60,000 seeds/lb. Mini: 10 seeds. Packet: 25 seeds.\n",
  },
  {
    id: "5284202015360165565",
    parentId: "3317392024211927600",
    plantName: "Tomato",
    seedName: "Frederik",
    seedDescription:
      "\nFrederik produces 7-9 oz., beefsteak tomatoes with very good flavor. Deep round fruits have light ribbing. Short internode length results in a compact plant, which works well for shorter greenhouses. Similar plant habit as Trust, with larger fruit size. Good greenhouse disease package. High resistance to fusarium wilt races 1, 2, fusarium crown and root rot, leaf mold, tomato mosaic virus; and intermediate resistance to powdery mildew. Indeterminate. Avg. 160,000 seeds/lb. Packet: 15 seeds.\n",
  },
  {
    id: "-4525128847729467931",
    parentId: "3317392024211927600",
    plantName: "Tomato",
    seedName: "Sakura",
    seedDescription:
      "\nReal sweet tomato flavor and firmness without being hard. Among the first to ripen, Sakura keeps going all season long because of its disease resistance. Very tidy, compact plant fits well in tight spaces. Prolific yielder of bright-red, shiny, medium-large cherry tomatoes that average 20-22 gm. High resistance to fusarium wilt, leaf mold, and tobacco mosaic virus; and intermediate resistance to nematodes. Indeterminate. Organically grown. Avg. 14,500 seeds/oz. Packet: 15 seeds.\n",
  },
  {
    id: "1458400132251572952",
    parentId: "3317392024211927600",
    plantName: "Tomato",
    seedName: "Toronjina",
    seedDescription:
      "\nCompact, balanced plant for easier indoor production. Round 15-20 gm., orange fruits with sweet and tangy flavor. Pairs best with Favorita for quart sales. High resistance to fusarium wilt races 1 & 2, leaf molds A-E, and tobacco mosaic virus. Indeterminate. Avg. 175,000 seeds/lb. Packet: 15 seeds.\n",
  },
  {
    id: "-5502520138532355833",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Monflor",
    seedDescription:
      "\nSpeed up kitchen prep. Monflor was bred for a flat and loose head, which allows floret separation with one cut. Floret quality is higher than those cut from standard heads. Market as bagged florets or whole heads. Avg. 75,000 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "-9137684080030594708",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Monflor",
    seedDescription:
      "\nSpeed up kitchen prep. Monflor was bred for a flat and loose head, which allows floret separation with one cut. Floret quality is higher than those cut from standard heads. Market as bagged florets or whole heads. Avg. 75,000 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "-9009892522110096830",
    parentId: "700119485825359714",
    plantName: "Pea",
    seedName: "Dwarf Grey Sugar Pea",
    seedDescription:
      '\nHarvest from 3-5". These small delicate shoots have a pleasant, sweet flavor and may be used as garnishes and in salads, stir fries, or soups. Avg. 3,400 seeds/lb.\n',
  },
  {
    id: "-3091611276530947247",
    parentId: "700119485825359714",
    plantName: "Pea",
    seedName: "Field Pea",
    seedDescription:
      '\nHarvest from 3-5". Dark green leaves, mild pea flavor, uniform germination. Avg. 2,700 seeds/lb.\n',
  },
  {
    id: "-7753297401023502255",
    parentId: "-4360259640222035586",
    plantName: "Corn",
    seedName: "Popcorn",
    seedDescription:
      '\nAttractive bright yellow when blanched. Harvested from 3-4" or any size that the market prefers, corn shoots can be eaten fresh, added to salads, or used in a wide variety of dishes. Avg. 3,750 seeds/lb.\n',
  },
  {
    id: "3895805830603113886",
    parentId: "700119485825359714",
    plantName: "Pea",
    seedName: "Tendril Pea",
    seedDescription:
      "\nThe same great flavor with a slightly lighter-green color. Avg. 1,800 seeds/lb.\n",
  },
  {
    id: "7386128639563681591",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Mardi",
    seedDescription:
      "\nFor summer or fall harvest. Heads are smooth, large and heavy, and hold well in the field. The big plants have excellent wrappers (in good soils), resulting in very white heads. Performs best in fall, but is suitable for summer harvests. Best for northern regions. Avg. 125,000 seeds/lb. Packet: 50 seeds.\n",
  },
  {
    id: "1456832336209506998",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Mardi",
    seedDescription:
      "\nFor summer or fall harvest. Heads are smooth, large and heavy, and hold well in the field. The big plants have excellent wrappers (in good soils), resulting in very white heads. Performs best in fall, but is suitable for summer harvests. Best for northern regions. Avg. 125,000 seeds/lb. Packet: 50 seeds.\n",
  },
  {
    id: "-5274160266129124915",
    parentId: "4069522599651715316",
    plantName: "Onion",
    seedName: "Ailsa Craig",
    seedDescription:
      "\nA distinct strain of the classic sweet and mild Ailsa Craig, this line has been specifically selected to perform in organic management systems. Mild onion with excellent size potential. Jumbo to colossal, round to teardrop-shaped bulbs with light-yellow skins. Use fresh or for short-term storage. Adaptation: 38-60° latitude. Avg. 110,000 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "-567621506222405132",
    parentId: "4069522599651715316",
    plantName: "Onion",
    seedName: "Cabernet",
    seedDescription:
      "\nCabernet produces medium-large globe-shaped onions with deep red color. Late-intermediate adaptation gives an earlier harvest than long-day reds without sacrificing size. Good internal color, mostly single centers. 4-6 month storage. Adaptation: 35-45° latitude. Select organic or conventional seeds. Also available pelleted. Avg. 119,800 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "4720520322380173287",
    parentId: "4069522599651715316",
    plantName: "Onion",
    seedName: "Gabriella",
    seedDescription:
      "\nDense, jumbo-sized bulbs with globe shape. Very similar to Madalyn, which is currently not available. Vigorous foliage. Imparts mild flavor with a touch of heat. For fall planting/spring harvest in the South. Early midseason maturity. Best for short storage (2-3 months). Adaptation: 20-35° latitude. Avg. 115,000 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "2816348138347520824",
    parentId: "4069522599651715316",
    plantName: "Onion",
    seedName: "Monastrell",
    seedDescription:
      "\nExcellent field-holding capacity. Slightly-flattened globes are large to jumbo-size. Rich red skin color permeates the internal rings. A good choice to follow Cabernet for late-season onions in a wide range of latitudes. Strong tops withstand thrips and foliar disease. Stores approx. 3-5 months. Avg. 120,000 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "-713184891989625936",
    parentId: "4069522599651715316",
    plantName: "Onion",
    seedName: "Patterson",
    seedDescription:
      "\nOffered in single-variety bunches (Units) averaging 50-60 plants each. 3 Unit, 5 Unit, and 30 Unit quantity orders must each consist of one variety; no mixing and matching. Patterson has the same firmness and storage qualities as Copra, with a larger size, better uniformity, and higher yield potential. Medium-large, blocky bulbs with dark yellow skin and thin necks that dry quickly. Adaptation: 38-55° latitude. Also available as seeds.\n",
  },
  {
    id: "8253403343513463368",
    parentId: "4069522599651715316",
    plantName: "Onion",
    seedName: "Redwing",
    seedDescription:
      "\nUniform, large onions with deep red color. Thick skin, very hard bulbs. Good red color in the rings. Better in higher latitudes than our other reds. Due to the late maturity, many growers choose to grow this from transplanting. Adaptation: 43-65° latitude. NOTE: Also offered as plants. Select organic or conventional seeds. Organic seeds are also offered pelleted. Organically grown. Avg. 110,300 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "-3712519525794883826",
    parentId: "4069522599651715316",
    plantName: "Onion",
    seedName: "Scout",
    seedDescription:
      "\nAttractive, jumbo to colossal bulbs are globe to slightly grano-shaped. Very good skin retention for type. Scout has mild to slightly pungent flavor and stores approx. 3-4 months. Replaces Great Western. High resistance to fusarium basal rot and pink root. Adaptation: 32-46° latitude. Avg. 110,100 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "117712501061624317",
    parentId: "4069522599651715316",
    plantName: "Onion",
    seedName: "Sierra Blanca",
    seedDescription:
      "\nWidely adapted, day-neutral, and matures well anywhere in North America from spring sowing. Suitable for fall planting where short-day onions are normally grown. Produces uniform, large, white-skinned onions with mild flavor and thick rings. Not for long storage. Sierra Blanca is the same variety as Super Star. It has been renamed by the breeder. Intermediate resistance to pink root. AAS winner. NOTE: Also offered as plants. Avg. 117,800 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "-461429777879293182",
    parentId: "4069522599651715316",
    plantName: "Onion",
    seedName: "Walla Walla Sweet",
    seedDescription:
      '\nJuicy, sweet, regional favorite. In the Northwest, which has normal low winter temperatures above -10°F/-23°C, seed is sown in late August, and a crop of very large, flattened, ultra-mild onions is harvested early the next summer. SPRING PLANTING: Walla Walla may be spring planted using seeds or plants in colder regions where winter survival is hit or miss. It is not as big or sweet as the wintered-over crop, but still milder and juicier than others from spring planting. Nice as a "green top" onion. Not for storage. Adaptation: 35-55° latitude. NOTE: Also offered as plants. Organically grown. Avg. 115,300 seeds/lb. Packet: 250 seeds.\n',
  },
  {
    id: "4497496199780333319",
    parentId: "4651840539936356394",
    plantName: "Cantaloupe",
    seedName: "Arava",
    seedDescription:
      "\nWidely adapted. Uniform, extra-sweet eating quality. Produces high yields of heavily netted, 3-4 lb. melons. Extended harvest. Harvest at full slip, when the skin of the fruit is yellow. Intermediate resistance to powdery mildew. Organically grown. Avg. 12,600 seeds/lb. Packet: 30 seeds.\n",
  },
  {
    id: "1017627758425546092",
    parentId: "4651840539936356394",
    plantName: "Cantaloupe",
    seedName: "Athena",
    seedDescription:
      "\nRipe melons seldom crack and have a tough rind, making them ideal for shipping. Good shelf life even when harvested ripe. Widely adapted. Fruits avg. 5-6 lb. Intermediate resistance to fusarium wilt races 0-2 and powdery mildew. Avg. 15,800 seeds/lb. Packet: 30 seeds.\n",
  },
  {
    id: "-6023743384565136105",
    parentId: "4651840539936356394",
    plantName: "Cantaloupe",
    seedName: "Brilliant",
    seedDescription:
      '\nThe smooth yellow melons avg. 5-5 1/2" X 4 1/2-5 1/2", and about 4 lb. Flesh is very sweet and juicy. Harvest when fruit turns dark yellow, at forced-slip stage, or cut from vine. Avg. 13,600 seeds/lb. Packet: 30 seeds.\n',
  },
  {
    id: "3992224907154923657",
    parentId: "4651840539936356394",
    plantName: "Cantaloupe",
    seedName: "Diplomat",
    seedDescription:
      "\nConcentrated set of 5-6 lb. fruits is produced on healthy vigorous vines. Thick, aromatic, sweet green flesh is of exceptional eating quality. Small seed cavity. Harvest at full slip, when the skin of the fruit is yellow. Intermediate resistance to powdery mildew. Avg. 23,600 seeds/lb. Packet: 30 seeds.\n",
  },
  {
    id: "5340427225579502507",
    parentId: "4651840539936356394",
    plantName: "Cantaloupe",
    seedName: "Divergent",
    seedDescription:
      "\nBred and trialed to withstand the stressors of organic cropping systems, these 3 1/2-4 lb. heavily-netted fruits have an excellent, sweet, aromatic flavor. Harvest at forced slip or cut from the vine when the skin is mostly yellow but still shows a 30-40% green hue. High resistance to fusarium wilt races 0, 1, and 2; intermediate resistance to powdery mildew. Avg. 15,000 seeds/lb. Packet: 15 seeds.\n",
  },
  {
    id: "-8828219620001184087",
    parentId: "4651840539936356394",
    plantName: "Cantaloupe",
    seedName: "Eden's Gem",
    seedDescription:
      "\nPopular green-flesh muskmelon with a heavily netted rind, and smooth, sweet-flavored flesh. Fruits avg. 2-3 lb. A good keeper with firm flesh. Organically grown. Avg. 18,300 seeds/lb. Packet: 30 seeds.\n",
  },
  {
    id: "-9089528059240505607",
    parentId: "4651840539936356394",
    plantName: "Cantaloupe",
    seedName: "Escorial",
    seedDescription:
      "\nEscorial matures nearly a week before Savor to serve the early Charentais market. Fruits avg. 2 lb, and are round to round-oval with pronounced sutures and moderate netting. Dark orange, very sweet, and aromatic flesh. Outer skin is green with a yellow tinge when ripe. Intermediate resistance to fusarium wilt races 1,2 and powdery mildew. Avg. 20,900 seeds/lb. Packet: 15 seeds.\n",
  },
  {
    id: "-712733764680330617",
    parentId: "4651840539936356394",
    plantName: "Cantaloupe",
    seedName: "Halona",
    seedDescription:
      "\nBe the first to market with Halona. Fruits mature extra early, avg. 4-5 lb., and have an excellent flavor. Intermediate resistance to fusarium wilt races 0-2 and powdery mildew. Avg. 19,900 seeds/lb. Packet: 30 seeds.\n",
  },
  {
    id: "-8762008607744017624",
    parentId: "4651840539936356394",
    plantName: "Cantaloupe",
    seedName: "Honey Blonde",
    seedDescription:
      "\nThe attractive oval fruits avg. 3-3 1/2 lb., and have sweet and delicious orange flesh. Plants are strong and vigorous and perform well in warm or cool weather. Intermediate resistance to powdery mildew. Avg. 20,500 seeds/lb. Packet: 30 seeds.\n",
  },
  {
    id: "-439579504571483643",
    parentId: "4651840539936356394",
    plantName: "Cantaloupe",
    seedName: "Honey Orange",
    seedDescription:
      "\nHoney-sweet, tender, crisp, pale salmon-orange flesh is thick and delicious to the rind. Medium-sized, avg. 3 lb., oval-round melons with smooth, ivory skin. Early maturity, and tolerant of cool conditions. 10-15 day shelf life. Avg. 19,900 seeds/lb. Packet: 30 seeds.\n",
  },
  {
    id: "3620576784014295007",
    parentId: "4651840539936356394",
    plantName: "Cantaloupe",
    seedName: "Honey White",
    seedDescription:
      "\nSmooth, round to oval-round fruits are very sweet, flavorful, and slow to crack even in cool, cloudy weather. The 3-3 1/2 lb. melons hold well on the vine or after being harvested. Avg. 19,800 seeds/lb. Packet: 30 seeds.\n",
  },
  {
    id: "1592553886749006332",
    parentId: "4651840539936356394",
    plantName: "Cantaloupe",
    seedName: "Lambkin",
    seedDescription:
      "\nMedium small, oval fruits avg. 3 lb. with yellow skin with green mottling. Very sweet, aromatic white flesh. Widely grown in Spain. Lambkin is more widely adapted, and earlier, than typical piel de sapos, with excellent uniformity and good yield. For best flavor, harvest when the fruit turns from green to yellowish green and slips from the vine. Melons may also be cut from the vine before slip for better shelf life (up to 7 days) but this will result in slightly less sweet fruits. AAS winner. Intermediate resistance to fusarium wilt races 1,2. Avg. 12,000 seeds/lb. Packet: 30 seeds.\n",
  },
  {
    id: "710585772916026031",
    parentId: "4651840539936356394",
    plantName: "Cantaloupe",
    seedName: "Lilly",
    seedDescription:
      "\nFruits average 6-8 lb. Skin is pale yellow with juicy, light-orange flesh with a distinctive sweet and spicy flavor. Lilly is much earlier than most crenshaws and will perform much better than older varieties in regions with short seasons. Harvest at forced slip. Intermediate resistance to powdery mildew and watermelon mosaic virus. Avg. 15,600 seeds/lb. Packet: 30 seeds.\n",
  },
  {
    id: "-8365688148418491674",
    parentId: "4651840539936356394",
    plantName: "Cantaloupe",
    seedName: "San Juan",
    seedDescription:
      '\nHeavily-netted oval fruits avg. 4 1/2 lb. Wonderfully aromatic, pear-like, sweet, and slightly spicy flavor. In warmer conditions, ananas melons are among the sweetest. Ivory colored flesh. Fruits avg. 8" x 6 1/2". Fruit is ripe when skin is mostly yellow and melons slip from vine. Intermediate resistance to fusarium wilt races 0-2, and powdery mildew. Avg. 10,400 seeds/lb. Packet: 30 seeds.\n',
  },
  {
    id: "8067955097544708630",
    parentId: "4651840539936356394",
    plantName: "Cantaloupe",
    seedName: "Savor",
    seedDescription:
      "\nUnsurpassed eating quality. The small, 2-lb melons are of the classic Charentais type: faintly ribbed, with a smooth gray-green rind and dark-green sutures. Sweet and aromatic, deep-orange flesh. High resistance to fusarium wilt races 0-2; and intermediate resistance to powdery mildew. Avg. 17,000 seeds/lb. Packet: 15 seeds.\n",
  },
  {
    id: "3408586035663379340",
    parentId: "4651840539936356394",
    plantName: "Cantaloupe",
    seedName: "Snow Leopard",
    seedDescription:
      "\nBeautiful, unique, personal-sized melons average 2 lb. Excellent for specialty and farmers' markets and restaurant sales. Very good, sweet flavor. High resistance to fusarium wilt race 1. Avg. 24,600 seeds/lb. Packet: 15 seeds.\n",
  },
  {
    id: "8439153796709552230",
    parentId: "4651840539936356394",
    plantName: "Cantaloupe",
    seedName: "Sugar Cube",
    seedDescription:
      "\nSugar Cube lives up to its name with intensely sweet flavor. Boasts a strong disease package. Yields very uniform, heavily-netted 2-4 lb. fruits with deep-orange, aromatic flesh. Fruits are just a bit bigger than a softball. Compared to Tasty Bites, which it replaces, it performs better in the South because of added virus resistance. It is also slightly smaller and has a longer harvest period. Sugar Cube is well-suited for Northern and Southern growers. High resistance to Fusarium wilt races 0-2, powdery mildew, and watermelon mosaic virus; intermediate resistance to papaya ringspot virus and zucchini yellow mosaic virus. Avg. 20,300 seeds/lb. Packet: 30 seeds.\n",
  },
  {
    id: "-2906755528769907511",
    parentId: "4651840539936356394",
    plantName: "Cantaloupe",
    seedName: "Sweet Granite",
    seedDescription:
      "\nDeveloped for far northern, coastal, and mountain climates. Gardeners in these difficult, cool-weather areas often grow their first ripe melons ever using this variety. The oblong, orange-fleshed fruits have light netting, and average about 3 lb. Melons are sweet with average flavor. Released in 1966 by the late Prof. Meader, Univ. of New Hampshire. Organically grown. Avg. 17,800 seeds/lb. Packet: 30 seeds.\n",
  },
  {
    id: "-4016640848454404454",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Broccoli",
    seedDescription:
      "\nHealthy and spicy. All of Johnny's high-germination sprouting seeds have tested negative for the presence of E. coli 0157 and Salmonella. Most are certified organic, designated by the OG symbol. Organically grown. Avg. 136,500 seeds/lb.\n",
  },
  {
    id: "8945413709659509002",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Broccoli",
    seedDescription:
      "\nHealthy and spicy. All of Johnny's high-germination sprouting seeds have tested negative for the presence of E. coli 0157 and Salmonella. Most are certified organic, designated by the OG symbol. Organically grown. Avg. 136,500 seeds/lb.\n",
  },
  {
    id: "-5016972437063075341",
    parentId: "-4095164293414183953",
    plantName: "Radish",
    seedName: "Radish, China Rose",
    seedDescription:
      "\nGreen leaves and pinkish stems. All of Johnny's high-germination sprouting seeds have tested negative for the presence of E. coli 0157 and Salmonella. Most are certified organic, designated by the OG symbol. Organically grown. Avg. 50,400 seeds/lb.\n",
  },
  {
    id: "-3906172996127123845",
    parentId: "-4095164293414183953",
    plantName: "Radish",
    seedName: "Radish, Triton",
    seedDescription:
      "\nTriton has purple stems and light-to-medium green cotyledons. Avg. 43,400 seeds/lb.\n",
  },
  {
    id: "2258178802916331823",
    parentId: "-4360259640222035586",
    plantName: "Corn",
    seedName: "American Dream",
    seedDescription:
      "\nExceptionally tender and sweet. The finest eating quality available in sweet corn. Produces tidy ears that look great on the farm stand and deliver on fresh-market flavor. Adaptable variety with excellent tip fill and strong husk protection. Replaces Xtra-Tender 277A. Intermediate resistance to northern corn leaf blight. AAS winner. Avg. 3,500 seeds/lb. Packet: 150 seeds.\n",
  },
  {
    id: "-8869389414815120771",
    parentId: "-4360259640222035586",
    plantName: "Corn",
    seedName: "Kickoff XR",
    seedDescription:
      "\nNew benchmark for flavor in this maturity slot. Exceptional quality. Large, attractive ears. Excellent husk package and tip fill. Replaces Xtra-Tender 2171. High resistance to common rust. Select treated or untreated seeds. Avg. 2,800 seeds/lb. Packet: 150 seeds.\n",
  },
  {
    id: "3923069441482314643",
    parentId: "-4360259640222035586",
    plantName: "Corn",
    seedName: "SS2742",
    seedDescription:
      "\nWidely-adapted variety with excellent eating quality and husk protection. Superior shelf life when compared to super sweets. 6 1/2-7\" ears are filled with 16-18 rows of sweet kernels. 6 1/2-7' plants. High resistance to northern corn leaf blight, common rust, and southern corn leaf blight. Plant Patents #8822756, #6184438, and #8796504. Avg. 2,900 seeds/lb. Packet: 150 seeds.\n",
  },
  {
    id: "-3833846658486241947",
    parentId: "-4360259640222035586",
    plantName: "Corn",
    seedName: "Vision MXR",
    seedDescription:
      "\nSame fantastic flavor as the original Vision. 8\" long ears with tender, bright yellow kernels in 16-18 rows. Excellent husk protection and good cool-soil vigor. Fans of Vision will not be disappointed by this improved version. 6 1/2' plants. Intermediate resistance to maize dwarf mosaic virus, northern corn leaf blight, and common rust. Select 6073T (Treated) or 6036 (Untreated). Avg. 3,200 seeds/lb. Packet: 150 seeds.\n",
  },
  {
    id: "165033240995550102",
    parentId: "-4360259640222035586",
    plantName: "Corn",
    seedName: "Xtra-Tender 20173",
    seedDescription:
      "\n7Œ_-8\" long ears with 16-18 rows of sweet, tender kernels. Ears have good tip fill and husk cover, snap easily from the stalk, and have a long shelf life. Sweeter and more tender than Xtra-Tender 2573, which it replaced. 6' plants. Intermediate resistance to common rust and Stewart's wilt. Select 3262T (Treated) or 3262 (Untreated). Avg. 4,000 seeds/lb. Packet: 150 seeds.\n",
  },
  {
    id: "6926933865926862195",
    parentId: "-4360259640222035586",
    plantName: "Corn",
    seedName: "Xtra-Tender 2171",
    seedDescription:
      "\nThis is the first time a super sweet corn variety has ever been offered in organic seed. Better husk protection and tighter, more attractive husks than Xtra-Tender 270A, which it replaced. 16 straight, refined rows on ears that are 8-8 1/2\". 6' plants. Good cool-soil vigor compared to other sh2 varieties. Intermediate resistance to southern corn leaf blight and Stewart's wilt. Avg. 3,300 seeds/lb. Packet: 150 seeds.\n",
  },
  {
    id: "-1914648666533761272",
    parentId: "700119485825359714",
    plantName: "Pea",
    seedName: "Avalanche",
    seedDescription:
      '\nPods are typically harvested at 3Œ_-4" but may be harvested at 2Œ_" for extra-fancy snow peas. Plants are high yielding. The vines avg. 36" and are of the semi-afila type, which produces more tendrils than typical peas. Tendrils make excellent garnishes. May be grown with or without support. High resistance to fusarium wilt race 1. Avg. 1,700 seeds/lb. Packet: 250 seeds.\n',
  },
  {
    id: "-3263075142270217681",
    parentId: "700119485825359714",
    plantName: "Pea",
    seedName: "Dwarf Grey Sugar",
    seedDescription:
      '\nAn old snow pea variety now cast in additional roles for its crops of red blossoms and subtly reddish-tinted stems and leaves. Shoots are used as garnishes and in salad mixes. Preferred for both taste and tenderness. Small snow pea pods avg. 2Œ_" long. 28" vines may be grown with or without support.��¢ Edible Flowers: The flowers, with their mild and pea-like flavor, are a popular choice for brightening up salad mix. They can also be used in micro mix salads, as a garnish for desserts, or for candying to place on cakes.  Avg. 3,400 seeds/lb.\n',
  },
  {
    id: "-2836815766802318576",
    parentId: "700119485825359714",
    plantName: "Pea",
    seedName: "Feisty",
    seedDescription:
      '\nVery sweet, medium-sized peas avg. 6-8 per pod. The 30" vines are of the afila type, which produces many tendrils but few leaves. This makes hand harvesting easier as plants are very upright and the 3Œ_" pods are more visible. Can be grown with or without support. The tendrils are popular as garnishes. High resistance to fusarium wilt race 1; and intermediate resistance to powdery mildew. Avg. 2,100 seeds/lb. Packet: 250 seeds.\n',
  },
  {
    id: "5281341776417550707",
    parentId: "700119485825359714",
    plantName: "Pea",
    seedName: "Golden Sweet",
    seedDescription:
      "\nAttractive yellow pods have best flavor when 3-3 1/2\". Larger pods will become slightly bitter and develop a small string. Big 5-6' vines need to be trellised. Long harvest window. Attractive purple flowers. Avg. 2,200 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "5936637806131985092",
    parentId: "700119485825359714",
    plantName: "Pea",
    seedName: "Maxigolt",
    seedDescription:
      "\nOutstanding late variety with large, very sweet, dark-green berries. Attractive, broad, 3 1/2\" pods. The vines avg. 3 1/2-4' (5' in fertile soil). Can be grown with or without support. Avg. 1,550 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "-1642011279986202603",
    parentId: "700119485825359714",
    plantName: "Pea",
    seedName: "Oregon Giant",
    seedDescription:
      '\nSweet berries inside big sweet pods combine for a delicious flavor treat. High yields of large, 4Œ_" x 1", medium-green, flat pods. The 30", white-flowered vines grow with or without support. High resistance to fusarium wilt race 1, pea enation mosaic virus, and powdery mildew. Bred by Dr. James Baggett of Oregon State Univ. Avg. 1,450 seeds/lb. Packet: 250 seeds.\n',
  },
  {
    id: "5430484893173975167",
    parentId: "700119485825359714",
    plantName: "Pea",
    seedName: "PLS 141",
    seedDescription:
      '\nFancy pods avg. 4-4 1/2" and have very good eating quality. Can be grown with or without support. Remove string prior to cooking. Better yield and vigor than Sugar Sprint, which it replaces. Avg. 2,200 seeds/lb. Packet: 250 seeds.\n',
  },
  {
    id: "-5187935740857214709",
    parentId: "700119485825359714",
    plantName: "Pea",
    seedName: "Penelope",
    seedDescription:
      '\nPenelope has extra long (avg.4Œ_"), fancy pods making it an excellent choice for retail sales. With 8-9 peas per pod end user yields are high. They are very easy to shell and have very good eating quality. 34" vines may be grown with or without support. High resistance to fusariu wilt races 1,2 and powdery mildew; and intermediate resistance to pea enation mosaic virus. Avg. 2,600 seeds/lb. Packet: 250 seeds.\n',
  },
  {
    id: "-5838559096411037567",
    parentId: "700119485825359714",
    plantName: "Pea",
    seedName: "Petite Snap-Greens",
    seedDescription:
      '\nGrown for its unique leaflets and edible shoots and blossoms. Harvest a few days after the leaflets have formed and are still tender. Whole plants can also be harvested when they are 6-8" tall. If cut above the first node, a second crop is possible. At this stage, the entire plant will be edible and is excellent for salads or light cooking. Vines will grow to 36" and don\'t need support, but the crop is usually harvested at 6-8" as described above. Petite Snap-Greens will produce snap peas but they mature rather late and yield less than standard snap peas. High resistance to fusarium wilt race 1 and powdery mildew. Avg. 1,750 seeds/lb. Packet: 250 seeds.\n',
  },
  {
    id: "6760174586833704788",
    parentId: "700119485825359714",
    plantName: "Pea",
    seedName: "Premium",
    seedDescription:
      '\n2 1/2-3" pods with avg. 7-8 very sweet, medium-sized peas per pod. 30" vines may be grown with or without support. High resistance to fusarium wilt race 1. Select 2669T (Treated) or 2669 (Untreated) Avg. 2,250 seeds/lb. Packet: 250 seeds.\n',
  },
  {
    id: "-4875907837791724142",
    parentId: "700119485825359714",
    plantName: "Pea",
    seedName: "Royal Snow",
    seedDescription:
      '\nAttractive pods avg. 3-3Œ_". Flavor is pleasant, though mildly bitter. Makes a nice addition to salads, coleslaws, or may be used as an edible garnish. Best used raw but may be lightly steamed, microwaved, or saut�©ed. Stays purple if lightly cooked but will become "muddy" colored if overcooked. Pods that are overmature, or exposed to high temperatures, may diminish in color to a mottled purple. Attractive pink flowers. The 30" vines can be grown with or without support. Avg. 1,700 seeds/lb. Packet: 250 seeds.\n',
  },
  {
    id: "8318227918948651996",
    parentId: "700119485825359714",
    plantName: "Pea",
    seedName: "Sienna",
    seedDescription:
      '\nSienna\'s vines are relatively short but set heavily for a high yield potential. Attractive pods avg. 3 1/2" long and contain 7-8 peas. 28" vines may be grown with or without support. High resistance to fusarium wilt races 1, 2. Select 2264T (Treated) or 2264 (Untreated). Avg. 2,200 seeds/lb. Packet: 250 seeds.\n',
  },
  {
    id: "4480225693881174978",
    parentId: "700119485825359714",
    plantName: "Pea",
    seedName: "Strike",
    seedDescription:
      '\nPods avg. 2 3/4" long with 7, medium-sized sweet peas. Vines are dark green, avg. 24" long, and can be grown with or without support. High resistance to fusarium wilt race 1. Select 2831T (Treated) or 2831 (Untreated). Avg. 2,450 seeds/lb. Packet: 250 seeds.\n',
  },
  {
    id: "4560858155222856356",
    parentId: "700119485825359714",
    plantName: "Pea",
    seedName: "Sugar Sprint",
    seedDescription:
      "\nAn almost stringless snap pea with excellent eating quality. Flavor as good as Sugar Ann. Diminished strings do not require removal before eating, making preparation faster and easier. 3\" pods grow on 2' vines that can be grown with or without support. High resistance to powdery mildew. Avg. 2,000 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "8443932556321915792",
    parentId: "700119485825359714",
    plantName: "Pea",
    seedName: "Super Sugar Snap",
    seedDescription:
      "\nAn earlier, somewhat shorter-vined version of Sugar Snap with the important addition of resistance to powdery mildew. The vines avg. 5' or more and need trellising. Early yields are heavier than Sugar Snap but the harvest period is shorter. The pods avg. 3\" and the flavor is good but not quite as sweet as Sugar Snap. High resistance to pea leaf roll virus and powdery mildew. Avg. 1,800 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "7148090170345526504",
    parentId: "8966395072127027946",
    plantName: "Carrot",
    seedName: "Gold Nugget",
    seedDescription:
      "\nSmall-cored Nantes type with improved flavor. Gold Nugget's 5-7\" deep-yellow roots feature vigorous and attractive, dark-green tops. Avg. 17,000 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "6467299711690078692",
    parentId: "8966395072127027946",
    plantName: "Carrot",
    seedName: "Yellowstone",
    seedDescription:
      "\nYellowstone's 6-8\" long roots are deeper in color than most other yellow carrot varieties. Nice, vigorous tops will compete with weeds. Compared to Yellowbunch, it is earlier and shorter with slightly blunter tip. Pairs well with Purple Haze and White Satin. Select organic or conventional seeds. Organic seed with NOP-compliant pelleting also available. Avg. 17,000 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "386506838266744175",
    parentId: "-6690279405914198363",
    plantName: "Spinach",
    seedName: "Bloomsdale",
    seedDescription:
      "\nDark-green leaves on upright plants make Bloomsdale easy to harvest. Heavily savoyed. Suited for early spring and fall plantings as it is fast growing. Also suitable for winter harvest. For full size and bunching. Great flavor. Unsized seed. Avg. 31,300 seeds/lb. Packet: 1,000 seeds.\n",
  },
  {
    id: "106944631389525487",
    parentId: "-6690279405914198363",
    plantName: "Spinach",
    seedName: "Carmel",
    seedDescription:
      "\nStunning dark green color and upright growth habit. For baby leaf or full size. Fast growing and highly uniform. High resistance to downy mildew races 1-11, 13. Avg. 54,000 seeds/lb. Packet: 1,000 seeds.\n",
  },
  {
    id: "4766875556157099059",
    parentId: "-6690279405914198363",
    plantName: "Spinach",
    seedName: "Corvair",
    seedDescription:
      "\nVery dark-green, uniform, oval leaves. Slow bolting. Upright plants hold well. High resistance to downy mildew races 1-11, 13. Organically grown. Avg. 44,700 seeds/lb. Packet: 1,000 seeds.\n",
  },
  {
    id: "-1256716516831551222",
    parentId: "-6690279405914198363",
    plantName: "Spinach",
    seedName: "Emperor",
    seedDescription:
      "\nUpright, dark green leaves with long stems are great for bunching. A moderate growth rate makes Emperor a good choice for spring and fall plantings. High resistance to downy mildew races 1-10. Avg. 41,900 seeds/lb. Packet: 1,000 seeds.\n",
  },
  {
    id: "-3338352507792390818",
    parentId: "-6690279405914198363",
    plantName: "Spinach",
    seedName: "Flamingo",
    seedDescription:
      "\nUniform, smooth, dark-green leaves on long stems. A great choice for bunching. Slower bolting compared to other varieties of this type. High resistance to downy mildew races 1-11; intermediate resistance to races 12-13. Avg. 24,800 seeds/lb. Packet: 1,000 seeds.\n",
  },
  {
    id: "-1485831038438380138",
    parentId: "-6690279405914198363",
    plantName: "Spinach",
    seedName: "Gazelle",
    seedDescription:
      "\nBest suited for fall harvest. Dark green, smooth, oval-to-round leaves with good flavor. Long stems, very uniform leaf shape and plant habit. Suitable for baby leaf and bunching. High resistance to downy mildew races 1-13. Avg. 36,600 seeds/lb. Packet: 1,000 seeds.\n",
  },
  {
    id: "-6196158906679016266",
    parentId: "-6690279405914198363",
    plantName: "Spinach",
    seedName: "Kolibri",
    seedDescription:
      "\nMedium-dark green leaves. Fast regrowth for ample cut-and-come-again harvest. We have seen growers crop Kolibri intensively for baby leaf production all season long. High resistance to downy mildew races 1-9, 12-15 and intermediate resistance to races 10, 11. Avg. 27,600 seeds/lb. Packet: 1,000 seeds.\n",
  },
  {
    id: "1515162327225698954",
    parentId: "-6690279405914198363",
    plantName: "Spinach",
    seedName: "Kookaburra",
    seedDescription:
      "\nUpright variety making it easy to harvest for both baby and full size leaves. Attractive dark-green, round leaves. Great flavor. High resistance to downy mildew races 1-13, 15. Avg. 30,800 seeds/lb. Packet: 1,000 seeds.\n",
  },
  {
    id: "2023135940327926909",
    parentId: "-6690279405914198363",
    plantName: "Spinach",
    seedName: "Red Kitten",
    seedDescription:
      "\nFor baby leaf production in the early spring or full-size bunching in the fall and winter. Uniform, smooth leaves are borne on fairly upright plants. High resistance to downy mildew races 1-13, 15. Avg. 44,900 seeds/lb. Packet: 1,000 seeds.\n",
  },
  {
    id: "7995418355378315637",
    parentId: "-6690279405914198363",
    plantName: "Spinach",
    seedName: "Reflect",
    seedDescription:
      "\nMedium-green, round-to-oval leaves on moderately upright plants. Reflect has performed well in our spring, summer, and fall trials. Slightly faster bolting than Tyee and technically a semi-savoy. High resistance to downy mildew races 1-11. Avg. 45,900 seeds/lb. Packet: 1,000 seeds.\n",
  },
  {
    id: "-5295276213568096514",
    parentId: "-6690279405914198363",
    plantName: "Spinach",
    seedName: "Seaside",
    seedDescription:
      "\nSeaside has upright, dark green leaves, that are somewhat spade shaped. Stays small, which extends the baby leaf harvest window. High resistance to downy mildew races 1-12; and intermediate resistance to race 14. Avg. 32,500 seeds/lb. Packet: 1,000 seeds.\n",
  },
  {
    id: "1841058693736774602",
    parentId: "-6690279405914198363",
    plantName: "Spinach",
    seedName: "Space",
    seedDescription:
      "\nMedium dark green leaves are upright and smooth to slightly savoyed. High resistance to downy mildew races 1, 2, 3, 5, 6, 8, 11, 12; and intermediate resistance to cladosporium leaf spot. Avg. 38,800 seeds/lb. Packet: 1,000 seeds.\n",
  },
  {
    id: "-8656760070289667788",
    parentId: "-6690279405914198363",
    plantName: "Spinach",
    seedName: "Woodpecker",
    seedDescription:
      "\nA great variety for late spring and summer harvests as it has been slow to bolt in our trials. Medium dark-green leaves. High resistance to downy mildew races 1-15. Avg. 28,500 seeds/lb. Packet: 1,000 seeds.\n",
  },
  {
    id: "3188166421400018237",
    parentId: "-6137866173690498356",
    plantName: "Eggplant",
    seedName: "Aretussa",
    seedDescription:
      '\nAttractive and uniform, 6-8" long by 2 1/2-3 1/2" diameter, cylindrical fruit. Suitable for heated and unheated structures, as well as open-field production. Well-branched, sturdy plants. Spineless. Green calyx. Avg. 85,000 seeds/lb. Packet: 25 seeds.\n',
  },
  {
    id: "5935380267909373065",
    parentId: "-6137866173690498356",
    plantName: "Eggplant",
    seedName: "Barbarella",
    seedDescription:
      '\nTender fruits are nearly round, 4-5" long by 4-6" diameter, with some small spines. Good yields with excellent flavor. Uniform with a medium gloss. Purple calyx. Avg. 6,200 seeds/oz. Packet: 25 seeds.\n',
  },
  {
    id: "-1166986400019884120",
    parentId: "-6137866173690498356",
    plantName: "Eggplant",
    seedName: "Beatrice",
    seedDescription:
      '\nSimilar in shape, flavor, and texture to Rosa Bianca. Earlier maturity, darker fruit color, and just slightly smaller (4-6" long by 4-5" diameter). Purple calyx. Avg. 7,700 seeds/oz. Packet: 25 seeds.\n',
  },
  {
    id: "6364615146352458801",
    parentId: "-6137866173690498356",
    plantName: "Eggplant",
    seedName: "Calliope",
    seedDescription:
      '\nCalliope is a beautiful, oval, Asian-style eggplant. Suitable for baby (2" long by 1 1/2" diameter) or mature (3-4" long by 2 1/4-2 3/4" diameter) harvest. High yielding, even in the North. The plants and calyxes are spineless, unlike many varieties of this type. Green calyx. Avg. 7,100 seeds/oz. Packet: 25 seeds.\n',
  },
  {
    id: "-7975167537318050830",
    parentId: "-6137866173690498356",
    plantName: "Eggplant",
    seedName: "Dancer",
    seedDescription:
      '\nSemi-cylindrical fruits are mid-sized (7-8" long by 3-4" diameter), mild, and nonbitter. Plants are strong and high yielding. Popular in Puerto Rico. Green calyx. Avg. 6,800 seeds/oz. Packet: 25 seeds.\n',
  },
  {
    id: "3541383665145502853",
    parentId: "-6137866173690498356",
    plantName: "Eggplant",
    seedName: "Fairy Tale",
    seedDescription:
      '\nAttractive, 2-4" long by 3/4-1 1/4" diameter, fruits are borne abundantly on compact 18-24" plants. Wonderful flavor with no bitterness and very few seeds. Some fruits may be harvested in clusters. Green calyx. AAS winner. Avg. 8,400 seeds/oz. Packet: 25 seeds.\n',
  },
  {
    id: "5176646868700797085",
    parentId: "-6137866173690498356",
    plantName: "Eggplant",
    seedName: "Galine",
    seedDescription:
      '\nVery glossy, uniform, black fruits are 6-7" long by 3-4" in diameter. Strong plants produce early, firm fruits. High yielding, even in the North. Green calyx. Avg. 6,800 seeds/oz. Packet: 25 seeds.\n',
  },
  {
    id: "720509371301399493",
    parentId: "-6137866173690498356",
    plantName: "Eggplant",
    seedName: "Hansel",
    seedDescription:
      '\nStart harvesting the abundant fruits when they are only 3-4" long by 3/4-1" diameter. The compact, 25-36" plants produce tender, dark-purple fruit in clusters for easy harvesting. Hansel is non-bitter and perfect for grilling or slicing thin onto pizza. Green calyx. AAS winner. Avg. 9,200 seeds/oz. Packet: 25 seeds.\n',
  },
  {
    id: "-2857825354132732126",
    parentId: "-6137866173690498356",
    plantName: "Eggplant",
    seedName: "Machiaw",
    seedDescription:
      '\nAvg. 9-10" long by 7/8-1" diameter fruits. Tender flesh. Strong plant with a nice continuous yield. TIP: For straightest fruits, prune and stake plants. Green calyx. Avg. 8,600 seeds/oz. Packet: 25 seeds.\n',
  },
  {
    id: "2915492960019299509",
    parentId: "-6137866173690498356",
    plantName: "Eggplant",
    seedName: "Nadia",
    seedDescription:
      '\nUniform, 7-8" long by 3-4" diameter, dark purple fruits are glossy and blemish free. Tall, sturdy plants can set fruit under cool conditions. Green calyx. Avg. 6,350 seeds/oz. Packet: 25 seeds.\n',
  },
  {
    id: "5396184528490605931",
    parentId: "-6137866173690498356",
    plantName: "Eggplant",
    seedName: "Nubia",
    seedDescription:
      '\nHarvest at 7-8" long by 3-4" diameter. Late and somewhat shy-yielding in the North. Green calyx. Avg. 5,500 seeds/oz. Packet: 25 seeds.\n',
  },
  {
    id: "6937123230528984892",
    parentId: "-6137866173690498356",
    plantName: "Eggplant",
    seedName: "Orient Charm",
    seedDescription:
      '\n8-10" long by 1 1/2-2 1/2" diameter. Compared to Orient Express, fruits are similar in shape but lighter in color, ranging from light lavender to bright purple. Blush of white at calyx end. Strong plant with high yields. Green calyx. Avg. 5,500 seeds/oz. Packet: 25 seeds.\n',
  },
  {
    id: "-8288393110871518659",
    parentId: "-6137866173690498356",
    plantName: "Eggplant",
    seedName: "Orient Express",
    seedDescription:
      '\nAttractive, slender, 8-10" long by 1 1/2-2 1/2" diameter, glossy . Ready up to 2 weeks before other early varieties, it features an ability to set fruit in cool weather as well as under heat stress. Tender, delicately flavored, and quick cooking. Purple calyx. Avg. 6,500 seeds/oz. Packet: 25 seeds.\n',
  },
  {
    id: "3305292636826915434",
    parentId: "-6137866173690498356",
    plantName: "Eggplant",
    seedName: "Paloma",
    seedDescription:
      "\nPaloma's bell-shaped fruits have distinctive ribbing and mildly sweet flavor and creamy texture. Short, healthy plants and more productive than Clara, which it replaces. Avg. 91,300 seeds/lb. Packet: 25 seeds.\n",
  },
  {
    id: "-7849772220187330167",
    parentId: "-6137866173690498356",
    plantName: "Eggplant",
    seedName: "Patio Baby",
    seedDescription:
      '\nBright-purple flowers add beauty to this compact, edible ornamental. Well-suited for balconies, patios, and gardens; also ideal for pack sales and urban farming operations. Patio Baby is a true mini, maintaining proper proportions of fruit to calyx as it grows. Thin-skinned 2-3" long by 2-3" diameter fruit with tender flavor, perfect for grilling or roasting. Continuous set. Spineless fruits make harvest pain free and child-friendly. AAS Regional (Northeast) Winner. Avg. 83,000 seeds/lb. Packet: 25 seeds.\n',
  },
  {
    id: "5655874190734300976",
    parentId: "-6137866173690498356",
    plantName: "Eggplant",
    seedName: "Rosa Bianca",
    seedDescription:
      '\nRound, 4-6" long by 5-7" diameter fruit streaked with white and violet. Plump and variably ribbed. Mild, creamy taste. This traditional Italian variety is best adapted to regions with warm nights; in cool areas expect low yields. Green calyx. Organically grown. Avg. 7,100 seeds/oz. Packet: 25 seeds.\n',
  },
  {
    id: "-2801809514621369576",
    parentId: "-6137866173690498356",
    plantName: "Eggplant",
    seedName: "Traviata",
    seedDescription:
      '\nGlossy black fruit in the classic bell shape, 5 1/2-6 1/2" long by 3-3 1/2" diameter. Good flavor. Very uniform and high yielding. Green calyx. Organically grown. Avg. 6,500 seeds/oz. Packet: 25 seeds.\n',
  },
  {
    id: "4657069151143367585",
    parentId: "-4095164293414183953",
    plantName: "Radish",
    seedName: "Bacchus",
    seedDescription:
      "\nBacchus is a perfect complement to Pink Beauty, Ping Pong, and any of our round red radishes. The skin is a deeper shade of purple than Amethyst, which it replaces. It is also earlier, rounder in shape, and much more uniform. A truly stunning radish! Recommended for early spring and fall harvest; flavor becomes quite hot in the heat of summer. Avg. 60,000 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "748109785137518582",
    parentId: "-4095164293414183953",
    plantName: "Radish",
    seedName: "Celesta",
    seedDescription:
      "\nCelesta's uniform, globe-shaped roots are bright red with smooth skin. Sweet, fairly mild flavor with a slight kick. Tops are short, but good for bunching. Not as heat tolerant as Rover, but suitable for summer sowing and growing. Avg. 65,000 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "584491665036818082",
    parentId: "-4095164293414183953",
    plantName: "Radish",
    seedName: "Cherriette",
    seedDescription:
      "\nSmooth and bright-red roots with short tops. Uniform and very slow to develop pith. For spring, summer, or early fall production. Dense and crisp with a sweet/hot taste. Avg. 53,100 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "7332771780528128164",
    parentId: "-4095164293414183953",
    plantName: "Radish",
    seedName: "D'Avignon",
    seedDescription:
      '\nRadishes are 3-4" long, slender, 2/3- 3/4 red, with a white tip, tapered to a point. Medium tops. Earlier than round radishes. Harvest promptly at maturity to avoid pithiness. This strain from Southern France was selected in our trials for exceptional uniformity and root quality. Sized seed. Avg. 36,500 seeds/lb. Packet: 250 seeds.\n',
  },
  {
    id: "-1814445624797497313",
    parentId: "-4095164293414183953",
    plantName: "Radish",
    seedName: "Easter Egg",
    seedDescription:
      "\nMake beautiful bunches with this mix of red, purple, and white round radishes. Maturing over an extended period of time, they stay crisp and mild even when large. Great fun for children and adults alike. Easter Egg II blend. Avg. 50,600 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "-2711580181888445360",
    parentId: "-4095164293414183953",
    plantName: "Radish",
    seedName: "Green Luobo",
    seedDescription:
      "\nAdds beautiful green color to kimchi. Also great for fresh eating. Uniform and fast maturing. Selected for its flavor profile, a nice balance of sweet and spicy. Replaces Green Meat. For summer planting/fall harvest. Not recommended for spring sowing, as it will bolt. Avg. 40,000 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "3522561578948119648",
    parentId: "-4095164293414183953",
    plantName: "Radish",
    seedName: "Nero Tondo",
    seedDescription:
      '\nThis elite strain is much more uniform and resistant to bolting than the ordinary Black Spanish variety. Large 2-4" (depending on harvest date) black-skinned, round roots with crisp, hot, white flesh. Suitable for sowing midspring (soil temp. 60°F/15°C or higher to prevent bolting) through fall. Thin to 4" apart. Avg. 50,300 seeds/lb. Packet: 250 seeds.\n',
  },
  {
    id: "-1010672887012193198",
    parentId: "-4095164293414183953",
    plantName: "Radish",
    seedName: "Pink Beauty",
    seedDescription:
      "\nUniform roots with medium tops. Nice, tender, crisp texture and taste. An eye-catching, top-quality radish. Resists pithiness. Organically grown. Avg. 50,700 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "-8298358195067440617",
    parentId: "-4095164293414183953",
    plantName: "Radish",
    seedName: "Red Meat",
    seedDescription:
      '\nLarge, 2-4" (depending on harvest date), round radishes with unique dark pink flesh. Large tops. Remarkably sweet, delicious taste. Great for pickling, fermenting, or winter salads. For summer to fall sowing only; will bolt to seed from spring sowing. Thin to 4" apart. Stores until early spring when kept at recommended storage conditions. Excellent fresh, grated, or cubed, and made into winter salads. Avg. 44,900 seeds/lb. Packet: 250 seeds.\n',
  },
  {
    id: "-5293087024997566803",
    parentId: "-4095164293414183953",
    plantName: "Radish",
    seedName: "Rover",
    seedDescription:
      "\nRover is extra early, holds well in the field, and has less of a tendency to produce oval radishes under heat stress than other varieties. The smooth, dark-red roots are extremely uniform and attractive with crisp, white flesh. Very widely adapted. Rover is our best round red radish. Avg. 45,600 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "-3378695233143899886",
    parentId: "-4095164293414183953",
    plantName: "Radish",
    seedName: "Roxanne",
    seedDescription:
      "\nRoxanne, like Rover, has the ability to produce good crops of round radishes, with very few ovals, in warm weather. It also has performed well in the spring and fall. Widely adapted. AAS winner. Avg. 41,300 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "-2463426213317378291",
    parentId: "-4095164293414183953",
    plantName: "Radish",
    seedName: "Shunkyo Semi-Long",
    seedDescription:
      '\nAvg. 4-5" long, rather smooth, cylindrical, deep pink roots with crisp white flesh. The flavor is both hot and unusually sweet. Edible, smooth, strapleaf foliage with rhubarb-pink stems. Slow bolting, and can be sown throughout the year. Avg. 53,900 seeds/lb. Packet: 250 seeds.\n',
  },
  {
    id: "1991752532608039051",
    parentId: "-4095164293414183953",
    plantName: "Radish",
    seedName: "Sora",
    seedDescription:
      "\nSora produces high-quality roots that maintain their crispness and resist pithiness even when oversized or in warm weather. Produces fewer oval roots in hot weather than Rudolf, which it replaced. Suitable for spring, summer, or fall crops. Organically grown. Avg. 48,200 seeds/lb. Packet: 250 seeds.\n",
  },
  {
    id: "-4635221102637262332",
    parentId: "-4095164293414183953",
    plantName: "Radish",
    seedName: "White Icicle Short Top",
    seedDescription:
      '\nSlender white roots grow to 4-5" and have a mild flavor. Large healthy tops. Avg. 48,200 seeds/lb. Packet: 250 seeds.\n',
  },
  {
    id: "6152968132247899176",
    parentId: "-8615932750481858489",
    plantName: "Celery",
    seedName: "Cutting Celery",
    seedDescription:
      "\nFinely-textured, intricate green leaves with light green stems. Avg. 1,311,000 seeds/lb.\n",
  },
  {
    id: "-4016640848454404454",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Broccoli",
    seedDescription: "\nDark-green leaves. Avg. 100,000 seeds/lb.\n",
  },
  {
    id: "8945413709659509002",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Broccoli",
    seedDescription: "\nDark-green leaves. Avg. 100,000 seeds/lb.\n",
  },
  {
    id: "-5521321990061834687",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Collard, VATES",
    seedDescription: "\nMild kale flavor. Avg. 114,500 seeds/lb.\n",
  },
  {
    id: "-4377722004400664910",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Collard, VATES",
    seedDescription: "\nMild kale flavor. Avg. 114,500 seeds/lb.\n",
  },
  {
    id: "5283845415255411705",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Kale, Toscano",
    seedDescription: "\nMild flavor. Avg. 146,300 seeds/lb.\n",
  },
  {
    id: "-2653357777005049470",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Kale, Toscano",
    seedDescription: "\nMild flavor. Avg. 146,300 seeds/lb.\n",
  },
  {
    id: "4574722450130182391",
    parentId: "6084674957358144924",
    plantName: "Potato",
    seedName: "Adirondack Blue",
    seedDescription:
      "\nHigh yields of large oblong tubers with consistent, dark blue-purple flesh that hold their color when cooked. High in antioxidants.\n",
  },
  {
    id: "-7240053668439167153",
    parentId: "6084674957358144924",
    plantName: "Potato",
    seedName: "Caribou Russet",
    seedDescription:
      "\nDeveloped by the University of Maine, this potato is excellent for baking and mashing. Moderate yields of very attractive, oval to oblong, russeted tubers that store well. Variety was bred for and performs best in cool climates, so should only be grown in the northern tier (New England and states that border Canada). Resistant to golden nematode race Ro1; moderately resistant to common scab and verticillium wilt.\n",
  },
  {
    id: "7596285953390920361",
    parentId: "6084674957358144924",
    plantName: "Potato",
    seedName: "Dark Red Norland",
    seedDescription:
      '\nSelected for richer red skin color. Round to oblong tubers have white flesh, store well, and are excellent for roasting and boiling. Plant at closer spacing (6-8") for small "new" potatoes. Resistant to Potato Virus A; moderate resistance to common scab and rhizoctonia. Organically grown.\n',
  },
  {
    id: "-4526851200829377962",
    parentId: "6084674957358144924",
    plantName: "Potato",
    seedName: "Elba",
    seedDescription:
      "\nLarge round tubers with buff skin, white flesh, and excellent flavor. The texture is best suited for roasting, boiling, baking, and salads. Good resistance to common scab. Organically grown.\n",
  },
  {
    id: "-3735887010887091697",
    parentId: "6084674957358144924",
    plantName: "Potato",
    seedName: "French Fingerling",
    seedDescription:
      "\nTall spreading plants produce tubers with pink skin and yellow flesh that is flecked with red. This variety is known for its gourmet quality flavor and is best boiled or roasted. Tubers are larger and more oval in shape than Russian Banana, and are resistant to common scab. Organic tubers are also available.\n",
  },
  {
    id: "815291757051338698",
    parentId: "6084674957358144924",
    plantName: "Potato",
    seedName: "Gold Rush",
    seedDescription:
      "\nMedium-large russeted tubers with dry, white flesh that store well and are suitable for baking and frying. Resistant to hollow heart; moderate resistance to verticillium wilt, blackspot, and scab.\n",
  },
  {
    id: "7996982682338842596",
    parentId: "6084674957358144924",
    plantName: "Potato",
    seedName: "Kennebec",
    seedDescription:
      '\nWidely-adapted, fast-growing plants do best when planted at 8-10" spacing to avoid overly-large tubers. High yields of round to oblong tubers with buff skin and white flesh that store well. Resistant to Potato Virus A and Potato Virus Y; moderate resistance to Potato Virus S, Potato Virus X, blackleg, and foliage late blight. Organic tubers are also available.\n',
  },
  {
    id: "7320879347711591573",
    parentId: "6084674957358144924",
    plantName: "Potato",
    seedName: "Magic Molly",
    seedDescription:
      "\nMagic Molly produces large, fingerling-shaped tubers with dark-purple skin and solid, dark-purple flesh that retains its color when boiled. Tubers have an excellent earthy flavor, especially when roasted. Can be dug as new potatoes for smaller fingerlings. Organically grown.\n",
  },
  {
    id: "-5331192346692904677",
    parentId: "6084674957358144924",
    plantName: "Potato",
    seedName: "Red Gold",
    seedDescription:
      "\nEarly variety with high yields of round tubers with light-red skin and delicious, yellow flesh. Excellent for roasting and boiling. Resistant to leaf roll and Potato Virus Y; moderate resistance to common scab. Not recommended for long storage.\n",
  },
  {
    id: "-4227936195247809861",
    parentId: "6084674957358144924",
    plantName: "Potato",
    seedName: "Russian Banana",
    seedDescription:
      "\nSmall plants produce large sets of small banana-shaped tubers with light-yellow skin and flesh. Excellent for roasting, boiling, and salads. Moderate resistance to common scab. Organic tubers are also available.\n",
  },
  {
    id: "946723305667694133",
    parentId: "6084674957358144924",
    plantName: "Potato",
    seedName: "Satina",
    seedDescription:
      "\nVigorous plants produce high yields of round to oval tubers. Their remarkable flavor makes them ideal for boiling and mashing. Stores well. High resistance to common scab and tuber late blight; moderate resistance to Potato virus Y. Organic tubers are also available.\n",
  },
  {
    id: "-5975424378345412751",
    parentId: "6084674957358144924",
    plantName: "Potato",
    seedName: "Yukon Gold",
    seedDescription:
      "\nLarge, upright plants produce round-oval tubers with yellow-buff skin and delicious, light-yellow flesh. Suitable for any cooking style and stores well. Resistant to PVA; moderately resistant to leaf roll. Susceptible to hollow heart which can be avoided with consistent soil moisture. Organically grown.\n",
  },
  {
    id: "-6747718152336587518",
    parentId: "262644758805253510",
    plantName: "Lettuce",
    seedName: "Adriana",
    seedDescription:
      "\nDeveloped by the same talented breeder who gave us Ermosa, Adriana is large and has a broad disease package. Heads are full and dense with good flavor. Good tolerance to tipburn, and bolting. High resistance to downy mildew races 1-16, 21, 23, and intermediate resistance to lettuce mosaic virus. MT0-30. Avg. 1,100 seeds/oz. Packet: 250 seeds.\n",
  },
  {
    id: "-4299585868453425604",
    parentId: "262644758805253510",
    plantName: "Lettuce",
    seedName: "Salanova�¬ Foundation Collection",
    seedDescription:
      "\nThis collection will add not only great flavor, but will increase the loft and weight of a salad mix. It can be used as a stand-alone mix, but is recommended to be combined with the Salanova�¬ Premier Collection to create a more dramatic offering. The collection includes equal amounts of each of the four incised leaf types in individual packages. NOTE: Three of the four types have been replaced with improved varieties. Suitable for mechanical harvesting or preparing with a knife. For complete disease resistance information, please refer to the individual components. Seed is pelleted using NOP-compliant pellets for planting ease. Utility Patent #5,977,443. MT0-30. This item can be shipped to Canada. Varies.\n",
  },
  {
    id: "-4066155442412057825",
    parentId: "262644758805253510",
    plantName: "Lettuce",
    seedName: "Salanova�¬ Green Butter",
    seedDescription:
      "\nNew and improved! Darker green, and more upright growth, than the previous Green Butter. Heads have a round base with open leaves. Delicate, buttery flavor. Great for selling as a whole head or in salad mix. Pair with either a red, core-type oak or red, core-type butter. High resistance to downy mildew races 16-32 and the Nasonovia ribisnigri aphid. Very good bolt tolerance. Utility Patents 5,977,443 and 6,320,104 and 9,131,658. Only available pelleted. Avg. 760 seeds/oz. Packet: 25 seeds.\n",
  },
  {
    id: "-1868734975665596030",
    parentId: "262644758805253510",
    plantName: "Lettuce",
    seedName: "Salanova�¬ Green Sweet Crisp",
    seedDescription:
      "\nMedium-dark green leaves with a very defined, three-dimensional shape. Sweet, almost romaine-like flavor, with a crisp, almost iceberg-like, texture. Large, heavy heads are slow to bolt. Suitable for mechanical harvesting. High resistance to downy mildew races 16-32 and Nasonovia ribisnigri aphid; intermediate resistance to lettuce mosaic virus. Utility Patent 5,977,443. Only available pelleted. Avg. 750 seeds/oz. Packet: 25 seeds.\n",
  },
  {
    id: "-1122828969663711969",
    parentId: "262644758805253510",
    plantName: "Lettuce",
    seedName: "Salanova�¬ Premier Collection",
    seedDescription:
      "\nThese cored types increase the flavor, color, and overall elegance of a salad mix. They can be used as a stand-alone mix, but it is recommended to be combined with the Salanova�¬ Foundation Collection to create a mix with greater volume and weight. The collection includes equal amounts of each of the four cored types in individual packages. When prepared with the cutter tool, heads easily fall into uniform, individual leaves. For complete disease resistance information, please refer to the individual components. Seeds are pelleted using NOP-compliant pellets for planting ease. Utility Patents #5,977,443, #6,320,104, and #9,131,658. MT0-30. This item can be shipped to Canada. Varies.\n",
  },
  {
    id: "-8101840149667622400",
    parentId: "262644758805253510",
    plantName: "Lettuce",
    seedName: "Salanova�¬ Red Butter",
    seedDescription:
      "\nTriple red heads have a round base with open leaves. Attractive red to green color transition. Delicate, buttery flavor. Great for selling as a whole head or in salad mix. Pair with either a red, core-type oak or red, core-type butter. High resistance to downy mildew races 16-32 and the Nasonovia ribisnigri aphid. Very good bolt tolerance. Utility Patents #5,977,443 and #6,320,104. Only available pelleted. Avg. 780 seeds/oz. Packet: 25 seeds.\n",
  },
  {
    id: "-3844886882193976643",
    parentId: "-1452327664920181626",
    plantName: "Pepper",
    seedName: "Ace",
    seedDescription:
      "\nHuge yields of medium sized 3-4 lobed fruits. Has apparent tolerance to blossom drop as nearly every flower produces a pepper. Widely adapted but performs particularly well in cool climates where bell peppers are difficult to grow successfully. Best for early crops and particularly good for pack sales. Avg. 4,900 seeds/oz. Packet: 25 seeds.\n",
  },
  {
    id: "-5469615278820064659",
    parentId: "-1452327664920181626",
    plantName: "Pepper",
    seedName: "Baron",
    seedDescription:
      '\nBaron has proven to produce better than other anchos under challenging and favorable conditions. The fruits are very large, avg. 5" x 3", and are typically two-lobed which makes them easy to stuff and cook in their signature dish, chile rellenos. More consistent than Tiburon, which it replaces, and has ranked at the top of our trials year after year. Baron was one of our most exciting new product additions for 2017. Avg. 39,000 seeds/lb. Packet: 25 seeds.\n',
  },
  {
    id: "-361474274042038382",
    parentId: "-1452327664920181626",
    plantName: "Pepper",
    seedName: "Carmen",
    seedDescription:
      '\nA beautiful pepper of the Italian "bull\'s horn" (corno di toro) type from Johnny\'s plant breeders Janika Eckert and Rob Johnston. Carmen has a lovely, sweet taste for salads and roasting, especially when partially or fully red-ripe. Tapered fruits avg. 6" long x 2 1/2" wide, 5 oz. (142 gm), and ripen from green to deep carmine red. Maturity is early on an upright, medium-size plant. Suitable for outdoor or indoor production. AAS winner. Also available organic (2993G). Avg. 4,200 seeds/oz. Packet: 25 seeds.\n',
  },
  {
    id: "8453693642320641459",
    parentId: "-1452327664920181626",
    plantName: "Pepper",
    seedName: "El Eden",
    seedDescription:
      '\nTall, strong plants produce high yields of smooth, 7-8" fruit. Only slightly hot, this type is often used for mole. It also makes excellent powder. Not recommended for fresh use, as the skins are relatively tough. Popular in Mexico. Avg. 75,000 seeds/lb. Packet: 25 seeds.\n',
  },
  {
    id: "3864858064114589198",
    parentId: "-1452327664920181626",
    plantName: "Pepper",
    seedName: "Escamillo",
    seedDescription:
      "\nAlso bred by Johnny's, Escamillo has attractively shaped golden fruit with similar lobed shoulders and a flavor that rivals Carmen's. The name comes from the French opera in which the gypsy Carmen falls in love with the bull-fighter Escamillo. Soon after Carmen was introduced, we began developing this perfect, golden-yellow partner. Fruits are 6\" long x 2-2 1/2\" wide. AAS winner. NOTE: While Escamillo is currently unavailable, we suggest you try Cornito Giallo. It is smaller than Escamillo, but still conical in shape, and should pair reasonably well with Carmen. Organically grown. Avg. 4,400 seeds/oz. Packet: 25 seeds.\n",
  },
  {
    id: "1699727719527612575",
    parentId: "-1452327664920181626",
    plantName: "Pepper",
    seedName: "Gourmet",
    seedDescription:
      "\nThick, juicy walls and fruity sweet flavor. Medium-large, very blocky bells are easy to grow under a wide variety of conditions. Strong compact plants set plentiful fruits without crowding. High resistance to tobacco mosaic virus. Avg. 5,000 seeds/oz. Packet: 25 seeds.\n",
  },
  {
    id: "-2208553309579687164",
    parentId: "-1452327664920181626",
    plantName: "Pepper",
    seedName: "Hot Rod",
    seedDescription:
      '\nHot Rod is a traditional serrano with avg 3" fruits borne on big plants over a long harvest period. The dark green fruits are traditionally eaten green but also make fine chipotles if allowed to ripen to red. A couple of days later, but much higher yielding, than Serrano Del Sol, which it replaced. Intermediate resistance to potato virus Y and tobacco etch virus. Avg. 3,900 seeds/oz. Packet: 25 seeds.\n',
  },
  {
    id: "672412353951337030",
    parentId: "-1452327664920181626",
    plantName: "Pepper",
    seedName: "Jedi",
    seedDescription:
      "\nOur largest jalapeno offering, Jedi's fruits avg. 4-4 1/2\" and are slow to check (show small cracks in skin). Large plants. A couple of days later than Jalafuego, but with bigger fruits. Resistant to bacterial leaf spot races 1-3. Avg. 65,000 seeds/lb. Packet: 25 seeds.\n",
  },
  {
    id: "1579045500538231544",
    parentId: "-1452327664920181626",
    plantName: "Pepper",
    seedName: "Lunchbox Pepper Mix",
    seedDescription:
      "\nEqual amounts of our red, yellow, and orange Lunchbox snack peppers have been combined in this mix. These beautiful, mini-sized peppers are remarkably sweet and flavorful. They are delicious saut�©ed, as an addition to salads and, of course, perfect for a healthy snack. All three varieties have tall strong plants that yield well for snack-type peppers. Sell the mixed colors loose or in clamshells. NOTE: Lunchbox Red is slightly smaller than the rest of the series. Organically grown. Avg. 5,100 seeds/oz. Packet: 25 seeds.\n",
  },
  {
    id: "-3651399117707177541",
    parentId: "-1452327664920181626",
    plantName: "Pepper",
    seedName: "Olympus",
    seedDescription:
      "\nWidely adapted, Olympus has performed well in both the South as well as warmer regions in the North. Medium size plants with good leaf cover. High-yielding, uniform fruit with good flavor. High resistance to bacterial leaf spot races 1-3. Avg. 60,000 seeds/lb. Packet: 25 seeds.\n",
  },
  {
    id: "7621824236155330331",
    parentId: "-1452327664920181626",
    plantName: "Pepper",
    seedName: "Red Ember",
    seedDescription:
      '\nThick enough for a bit of crunch when eaten fresh, but thin enough to dry easily. The fruits are sweet with moderately warm heat for a cayenne. "Pepper heads" can eat Red Ember fruits whole, while others craving a touch of heat can slice it thinly for salads. Makes excellent powder or flakes; also nice for hot sauce. Fruits avg. 4-4 1/2". AAS winner. Organically grown. Avg. 69,300 seeds/lb. Packet: 25 seeds.\n',
  },
  {
    id: "-1866506958423212212",
    parentId: "-1452327664920181626",
    plantName: "Pepper",
    seedName: "X3R�¬ Red Knight",
    seedDescription:
      "\nGet a jump on the season with a large, early, green-to-red pepper. Big, blocky, thick-walled bell pepper turns red early. Fruity and sweet. Widely adapted. High resistance to bacterial leaf spot races 1-3 and potato virus Y. Avg. 3,600 seeds/oz. Packet: 25 seeds.\n",
  },
  {
    id: "-1602570920677003110",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Beira",
    seedDescription:
      "\nThis unique specialty from Portugal is also called Portuguese cabbage or sea kale. The taste and texture of the wavy green leaves are similar to collards. The thick fleshy midribs and stems can be peeled and eaten like celery or included in the soup. Vigorous plants grow up to 2' high and 2' wide. Grow like regular kale but space plants 18-36\" in order for plants to reach full size. Beira will tolerate only moderate frost. Best for spring or fall harvest as it tends to get tipburn in hot weather. Avg. 58,000 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "4447113078929859656",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Beira",
    seedDescription:
      "\nThis unique specialty from Portugal is also called Portuguese cabbage or sea kale. The taste and texture of the wavy green leaves are similar to collards. The thick fleshy midribs and stems can be peeled and eaten like celery or included in the soup. Vigorous plants grow up to 2' high and 2' wide. Grow like regular kale but space plants 18-36\" in order for plants to reach full size. Beira will tolerate only moderate frost. Best for spring or fall harvest as it tends to get tipburn in hot weather. Avg. 58,000 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "8661042125403921712",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Black Magic",
    seedDescription:
      '\nBlack Magic is a well-maintained selection of Toscano kale with long, narrow leaves for attractive and tall, straight bunches. Dark blue-green leaves with beautiful savoy. Lacinato or "dinosaur" type kale. Avg. 150,000 seeds/lb.\n',
  },
  {
    id: "6107068126389231356",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Black Magic",
    seedDescription:
      '\nBlack Magic is a well-maintained selection of Toscano kale with long, narrow leaves for attractive and tall, straight bunches. Dark blue-green leaves with beautiful savoy. Lacinato or "dinosaur" type kale. Avg. 150,000 seeds/lb.\n',
  },
  {
    id: "-8323864681116968298",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Darkibor",
    seedDescription:
      "\nSimilar to Winterbor, Darkibor is just as tall, somewhat later to mature, and slightly less curled. The color is more of a medium green versus the darker and bluer green colors of Winterbor and Starbor. A sturdy kale, with tight curl and close internodes. Avg. 100,000 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "-5770307783084123957",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Darkibor",
    seedDescription:
      "\nSimilar to Winterbor, Darkibor is just as tall, somewhat later to mature, and slightly less curled. The color is more of a medium green versus the darker and bluer green colors of Winterbor and Starbor. A sturdy kale, with tight curl and close internodes. Avg. 100,000 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "2497954996297423070",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Olympic Red",
    seedDescription:
      "\nColor is variable, ranging from dark reddish-green with purple ribs to full-purple. Tightly curled leaves with long petioles make colorful bunches. Uniform size, shape, and yield with excellent vigor and cold hardiness. Sustained harvest from the lower leaves up, like Winterbor. NOTE: This seed is treated with food-grade diatomaceous earth. Avg. 173,300 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "-7796006218904625841",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Olympic Red",
    seedDescription:
      "\nColor is variable, ranging from dark reddish-green with purple ribs to full-purple. Tightly curled leaves with long petioles make colorful bunches. Uniform size, shape, and yield with excellent vigor and cold hardiness. Sustained harvest from the lower leaves up, like Winterbor. NOTE: This seed is treated with food-grade diatomaceous earth. Avg. 173,300 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "-4084058362688981064",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Redbor",
    seedDescription:
      "\nSimilar to Winterbor but purple-red. For garnishing and eating. Flavor, color, and curling are enhanced by cold weather. Avg. 103,700 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "6671001546912825625",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Redbor",
    seedDescription:
      "\nSimilar to Winterbor but purple-red. For garnishing and eating. Flavor, color, and curling are enhanced by cold weather. Avg. 103,700 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "-5839014483252934570",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Scarlet",
    seedDescription:
      "\nThe broad, frilly, purple leaves grow on 2-3' tall, upright stalks. Scarlet compares to Redbor in height, leaf shape, and color. Good uniformity for an open-pollinated variety. Great for baby leaf and bunching. Avg. 165,300 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "-6317962644244167033",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Scarlet",
    seedDescription:
      "\nThe broad, frilly, purple leaves grow on 2-3' tall, upright stalks. Scarlet compares to Redbor in height, leaf shape, and color. Good uniformity for an open-pollinated variety. Great for baby leaf and bunching. Avg. 165,300 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "-2573564701352879801",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Starbor",
    seedDescription:
      '\nThe finely-curled, dark blue-green leaves can be harvested with one cut as well as being stripped off the plant individually, as kale is traditionally harvested. The compact plants produce leaves that are very uniform, resist yellowing, and have good flavor. Short internodes allow for high yields despite compact habit. Perfect for harvesting the whole plant at 12-18". Avg. 145,700 seeds/lb. Packet: 100 seeds.\n',
  },
  {
    id: "3476797652990666782",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Starbor",
    seedDescription:
      '\nThe finely-curled, dark blue-green leaves can be harvested with one cut as well as being stripped off the plant individually, as kale is traditionally harvested. The compact plants produce leaves that are very uniform, resist yellowing, and have good flavor. Short internodes allow for high yields despite compact habit. Perfect for harvesting the whole plant at 12-18". Avg. 145,700 seeds/lb. Packet: 100 seeds.\n',
  },
  {
    id: "1073677185046892814",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Toscano",
    seedDescription:
      '\nLacinato or "dinosaur" type. Unique leaf type: extra-dark green, noncurled but heavily blistered (savoyed). Rich, tender leaves have a softer texture than curly green kales. Tolerant of hot and cold weather. Tested for Black Rot. Unsized seed. Select organic or conventional seed. Avg. 149,200 seeds/lb. Packet: 100 seeds.\n',
  },
  {
    id: "367263764617485442",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Toscano",
    seedDescription:
      '\nLacinato or "dinosaur" type. Unique leaf type: extra-dark green, noncurled but heavily blistered (savoyed). Rich, tender leaves have a softer texture than curly green kales. Tolerant of hot and cold weather. Tested for Black Rot. Unsized seed. Select organic or conventional seed. Avg. 149,200 seeds/lb. Packet: 100 seeds.\n',
  },
  {
    id: "-809765728837124873",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Winterbor",
    seedDescription:
      "\nThe plants are tall, growing up to 2-3', with excellent yield and better cold hardiness. Leaves are well-curled, blue-green, and ruffled. Vigorous plants will continue growing to produce leaves for successive harvests as the lower leaves are harvested. Sized seeds. Avg. 99,200 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "-2906109151875891417",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Winterbor",
    seedDescription:
      "\nThe plants are tall, growing up to 2-3', with excellent yield and better cold hardiness. Leaves are well-curled, blue-green, and ruffled. Vigorous plants will continue growing to produce leaves for successive harvests as the lower leaves are harvested. Sized seeds. Avg. 99,200 seeds/lb. Packet: 100 seeds.\n",
  },
  {
    id: "-3211312568236714773",
    parentId: "4992248545757731715",
    plantName: "Cucumber",
    seedName: "Adam Gherkin",
    seedDescription:
      '\nAdam Gherkin produces high yields of uniform fruits in a broad range of climates. European-style pickling cucumbers with great flavor, crisp texture, and even color. Nicely proportioned even at 2-3" gherkin size. Suitable for field or greenhouse production. Intermediate resistance to cucumber mosaic virus, powdery mildew, and scab. Gynoecious and parthenocarpic. Organically grown. Avg. 15,000 seeds/lb. Packet: 30 seeds.\n',
  },
  {
    id: "-8264051994951198428",
    parentId: "4992248545757731715",
    plantName: "Cucumber",
    seedName: "Corinto",
    seedDescription:
      '\nThis organic hybrid produces very dark green, uniform, 7-8" slicing cucumbers despite cool weather or heat. Small seed cavity. Skin is thick enough to endure harvesting and handling, but thinner than the average slicing cucumber. Remarkable vigor in both the field and greenhouse. Gynoecious and parthenocarpic. Intermediate resistance to cucumber mosaic virus, cucumber vein yellowing virus, and powdery mildew. Organically grown. Avg. 17,700 seeds/lb. Mini: 10 seeds. Packet: 30 seeds.\n',
  },
  {
    id: "5991883090245383804",
    parentId: "4992248545757731715",
    plantName: "Cucumber",
    seedName: "Diva",
    seedDescription:
      '\nDiva produces distinctly tender, crisp, sweet, bitter-free, and seedless cukes. Adapted to open field production and protected cropping. Harvest at 5-7". Gynoecious and parthenocarpic. High resistance to scab; and intermediate resistance to cucumber vein yellowing virus, downy mildew, and powdery mildew. AAS winner. Select 2198T (Treated) or 2198 (Untreated). Avg. 18,150 seeds/lb. Packet: 30 seeds.\n',
  },
  {
    id: "-2733387582045906192",
    parentId: "4992248545757731715",
    plantName: "Cucumber",
    seedName: "Excelsior",
    seedDescription:
      '\nExcelsior produces dark green, blocky, nicely proportioned, 4-5" cucumbers with American-style spines. Vigorous, balanced plant with consistent fruit setting. Excellent flavor. Also does well in screen houses, in the field under row cover, or wherever else pollinators are absent. Parthenocarpic and gynoecious. High resistance to scab and target spot; and intermediate resistance to cucumber mosaic virus, cucumber vein yellowing virus, and powdery mildew. Organically grown. Avg. 21,000 seeds/lb. Packet: 30 seeds.\n',
  },
  {
    id: "-2034310064896554158",
    parentId: "4992248545757731715",
    plantName: "Cucumber",
    seedName: "General Lee",
    seedDescription:
      '\nThough bred for the South, where General Lee is a widely-grown standard, it has also performed well in our Albion trials. Dark fruits with white spines are uniform, attractive, and average 8-8 1/2" long. The gynoecious plants have a high yield potential. 10% pollenizer added. High resistance to scab; and intermediate resistance to cucumber mosaic virus, downy mildew, and powdery mildew. Avg. 16,500 seeds/lb. Packet: 30 seeds.\n',
  },
  {
    id: "7296414013009068628",
    parentId: "4992248545757731715",
    plantName: "Cucumber",
    seedName: "H-19 Little Leaf",
    seedDescription:
      '\nBlocky, medium-length (3-5") fruits are good for fresh eating. They pickle well and have a distinctive, bright emerald green color. Vines are compact, multibranching, and yield well even under stress. Half normal-sized leaves provide easy visibility and harvesting. White spines. Parthenocarpic. High resistance to anthracnose, angular leaf spot, bacterial wilt, and scab; and intermediate resistance to cucumber mosaic virus, downy mildew, and powdery mildew. Organically grown. Avg. 24,000 seeds/lb. Packet: 30 seeds.\n',
  },
  {
    id: "5382051108115304931",
    parentId: "4992248545757731715",
    plantName: "Cucumber",
    seedName: "Iznik",
    seedDescription:
      '\nIznik produces good yields of 3 1/2-4" spineless, seedless, dark green snack cucumbers. Multiple fruits per node. Excellent flavor. Pick daily for best quality. Gynoecious and parthenocarpic. High resistance to powdery mildew and scab. Avg. 17,650 seeds/lb. Mini: 10 seeds. Packet: 30 seeds.\n',
  },
  {
    id: "-6354871262595630060",
    parentId: "4992248545757731715",
    plantName: "Cucumber",
    seedName: "Lemon",
    seedDescription:
      "\nPick at 1Œ_-2Œ_\" diameter. This versatile cucumber is sweet and flavorful, and doesn't have much of the chemical that makes other cucumbers bitter and hard to digest. Though often served raw, Lemon is also a good pickling cucumber. Specialty market salad item. NOTE: Very late to begin bearing. Organically grown. Avg. 18,500 seeds/lb. Packet: 30 seeds.\n",
  },
  {
    id: "4756410027559623543",
    parentId: "4992248545757731715",
    plantName: "Cucumber",
    seedName: "Marketmore 76",
    seedDescription:
      '\nLong, slender, dark green cucumbers. The slender, refined "Marketmore look" has long been the standard for slicing cucumbers in the North. 8-9" fruits stay uniformly dark green even under weather stress. Begins bearing late, but picks for a relatively long time. High resistance to scab; and intermediate resistance to cucumber mosaic virus, downy mildew, and powdery mildew. Select organic or conventional seeds. Avg. 20,000 seeds/lb. Packet: 30 seeds.\n',
  },
  {
    id: "-6844860159418412467",
    parentId: "4992248545757731715",
    plantName: "Cucumber",
    seedName: "Max Pack",
    seedDescription:
      "\nHuge yields of very uniform and attractive picklers borne on vigorous vines. Resists bitterness under stress. Small seed cavity, (a nice feature for a pickling cucumber). Similar appearance to Jackson Supreme, which it replaces, but is higher yielding and more disease resistant. High resistance to anthracnose, scab, watermelon mosaic virus, and zucchini yellow mosaic virus; intermediate resistance to angular leaf spot, cucumber mosaic virus, powdery mildew, and papaya ringspot virus. Avg. 16,000 seeds/lb. Packet: 30 seeds.\n",
  },
  {
    id: "1994514512046024948",
    parentId: "4992248545757731715",
    plantName: "Cucumber",
    seedName: "Northern Pickling",
    seedDescription:
      "\nMedium green fruits bear early, and set heavily on short, space-saving vines. Fertilize well and pick frequently at a small size to maintain good color and fruit shape. Developed in Maine. Black spine. High resistance to scab. Organically grown. Avg. 19,000 seeds/lb. Packet: 30 seeds.\n",
  },
  {
    id: "865818693564896399",
    parentId: "4992248545757731715",
    plantName: "Cucumber",
    seedName: "Olympian",
    seedDescription:
      "\nYear after year, Olympian continues to come out on top as the best tasting American-style slicer in our trials. Olympian's beautiful, dark green, straight, 8-9\" fruit are crisp with fresh flavor. Very uniform and productive over a long season, with exceptionally high proportions of marketable fruit. A winning combination of flavor, yield, and appearance. Gynoecious with 10% pollenizer added. Intermediate resistance to anthracnose, angular leaf spot, downy mildew, powdery mildew, and scab. Select 2903T (Treated) or 2903 (Untreated). Avg. 16,700 seeds/lb. Packet: 30 seeds.\n",
  },
  {
    id: "6136502399375799030",
    parentId: "4992248545757731715",
    plantName: "Cucumber",
    seedName: "SV4719CS",
    seedDescription:
      '\nStraight, dark green, slicing cucumber has good vigor and broad disease resistance. 8" long cukes are attractive and uniform with good flavor. Enough downy mildew resistance to extend the harvest by 1-3 pickings. Gynoecious. High resistance to anthracnose, angular leaf spot, downy mildew, scab, and zucchini yellow mosaic virus; and intermediate resistance to powdery mildew. Avg. 16,150 seeds/lb. Packet: 30 seeds.\n',
  },
  {
    id: "-1947620312220549980",
    parentId: "4651840539936356394",
    plantName: "Cantaloupe",
    seedName: "Striped Armenian",
    seedDescription:
      '\nAlso known as Painted Serpent. Unusual, slightly fuzzy, serpentine fruits are slightly ridged with alternating dark and light green stripes. Harvest from 8-18". Despite its shape, Striped Armenian is not a true cucumber, but is a member of the melon family. Delicious and different. Avg. 11,800 seeds/lb. Packet: 30 seeds.\n',
  },
  {
    id: "-8986827115592342833",
    parentId: "4992248545757731715",
    plantName: "Cucumber",
    seedName: "Suyo Long",
    seedDescription:
      '\nA sweet-flavored, ribbed fruit growing up to 15" long. Widely adapted, grows well in hot weather, and sets early. Try using this unusual-looking cucumber in salads, for bread-and-butter, or mixed vegetable pickles. Excellent eating quality. Bitter-free. Trellis for straight fruits. Organically grown. Avg. 15,600 seeds/lb. Packet: 30 seeds.\n',
  },
  {
    id: "-611601729151036040",
    parentId: "4992248545757731715",
    plantName: "Cucumber",
    seedName: "Tasty Jade",
    seedDescription:
      '\nVigorous, high-yielding plants produce glossy, thin-skinned, 11-12" long fruit with small seed cavities and bitter-free fruit. Peeling is not necessary. Sweeter and more crisp than any other long Japanese cucumbers we have trialed. Also, Tasty Jade is among the few parthenocarpic varieties of this type available today. Suitable for outdoor or greenhouse culture. Trellis for straight fruit. Parthenocarpic. Intermediate resistance to downy mildew and powdery mildew. Avg. 19,200 seeds/lb. Packet: 30 seeds.\n',
  },
  {
    id: "-6452223199419783431",
    parentId: "262644758805253510",
    plantName: "Lettuce",
    seedName: "Breen",
    seedDescription:
      '\nBreen forms a very compact, mini head early. The short plant averages 8" tall and is very slow to become oversized. Color is a medium bronze red. Though best for mini heads, it can also be used as a medium-red baby leaf. Especially nice marketed with other mini romaines. Utility Patent granted. High resistance to downy mildew races 1-21, 23-26, 28-32. MT0-30. Also available with NOP-compliant pelleting. Organically grown. Avg. 27,350 seeds/oz. Packet: 500 seeds.\n',
  },
  {
    id: "6384522921453313961",
    parentId: "262644758805253510",
    plantName: "Lettuce",
    seedName: "Cavendish",
    seedDescription:
      "\nUniform, upright growth. Compared to Blade, Cavendish is darker in color, has slightly better texture and flavor, and shows more uniformity in growth, shape, and color. Slightly slower growing than Blade. Resistant to downy mildew races 16-33. MT0-30. Avg. 350,000 seeds/lb. Packet: 500 seeds.\n",
  },
  {
    id: "-2838997252232290448",
    parentId: "262644758805253510",
    plantName: "Lettuce",
    seedName: "Cegolaine",
    seedDescription:
      "\nVery uniform, dense heads are slow to bolt. Great flavor. Pairs nicely with Rosaine and/or Newham for an attractive contrast between red and green. High resistance to downy mildew races 1-28, 30, 31, Nasonovia ribisnigri aphid, and lettuce root aphid; intermediate resistance to lettuce mosaic virus. MT0-30. Also available with NOP-compliant pelleting. Avg. 30,500 seeds/oz. Packet: 500 seeds.\n",
  },
  {
    id: "-585843238658530892",
    parentId: "262644758805253510",
    plantName: "Lettuce",
    seedName: "Dragoon",
    seedDescription:
      "\nCompact and uniform. Leaves are thick and have an excellent, crisp texture. Heads are very dense, hold well in the field, and can be attractively marketed with mini red romaines. Bolting and tipburn tolerant. For spring, summer, and fall. Suitable for hydroponic systems. Utility Patent granted. High resistance to downy mildew races 1-27, 29-32, Nasonovia ribisnigri aphid, and tomato bushy stunt virus (lettuce dieback complex); and intermediate resistance to lettuce mosaic virus. MT0-30. Also available with NOP-compliant pelleting. Organically grown. Avg. 20,500 seeds/oz. Packet: 500 seeds.\n",
  },
  {
    id: "-3990994778307610609",
    parentId: "262644758805253510",
    plantName: "Lettuce",
    seedName: "Ezbruke",
    seedDescription:
      '\nEzbruke features an open habit and small core, which makes it nice for one-cut or whole-head harvest. Deep-scarlet heads with attractive, red-speckled internal leaves - a rare color in lettuce. Can be grown at 4-6" spacing. Slow bolting; holds well in the field. High resistance to downy mildew races 1-8, 16-32, lettuce leaf aphid Nasonovia ribisnigri, tomato bushy stunt virus; intermediate resistance to lettuce mosaic virus. Avg. 450,000 seeds/lb. Packet: 500 seeds.\n',
  },
  {
    id: "897095611408793619",
    parentId: "262644758805253510",
    plantName: "Lettuce",
    seedName: "Rosaine",
    seedDescription:
      "\nCrisp leaves make uniform, dense heads with great flavor. Slow to bolt. Pairs nicely with Cegolaine and/or Newham. High resistance to downy mildew races 1-26, 28, 31, Nasonovia ribisnigri aphid, and lettuce root aphid. MT0-30. Also available with NOP-compliant pelleting. Avg. 26,400 seeds/oz. Packet: 500 seeds.\n",
  },
  {
    id: "5033785638334094370",
    parentId: "262644758805253510",
    plantName: "Lettuce",
    seedName: "Truchas",
    seedDescription:
      '\nThe compact, mini heads are dark red even in the North. Plants avg. 6-8" in height and fill out nicely. Market as a 3-pack with a green, and a bronze-red variety. Utility Patent granted. High resistance to downy mildew races 1-32 and tomato bushy stunt virus (lettuce dieback complex); and intermediate resistance to lettuce mosaic virus. MT0-30. Also available with NOP-compliant pelleting. Organically grown. Avg. 31,100 seeds/oz. Packet: 500 seeds.\n',
  },
  {
    id: "5281980600675664341",
    parentId: "3317392024211927600",
    plantName: "Tomato",
    seedName: "Amish Paste",
    seedDescription:
      "\nLarge for a sauce tomato, Amish Paste's slightly irregular plum-to strawberry shaped fruits avg. 8-12 oz. with excellent flavor. These meaty tomatoes are good in salads and great for processing. A Slow Food USA Ark of Taste variety. Indeterminate. Organically grown. Avg. 13,000 seeds/oz. Packet: 40 seeds.\n",
  },
  {
    id: "516063187656002036",
    parentId: "3317392024211927600",
    plantName: "Tomato",
    seedName: "Big Beef",
    seedDescription:
      "\nStill unsurpassed as the top choice for fresh market beefsteak tomatoes. Large, avg. 10-12 oz., mostly blemish-free, globe-shaped red fruit. They have full flavor - among the best - and ripen early for their size. Broad disease resistance package. High resistance to alternaria stem canker, fusarium wilt races 1, 2, gray leaf spot, nematodes, tobacco mosaic virus, and verticillium wilt. AAS winner. Indeterminate. Avg. 8,200 seeds/oz. Packet: 40 seeds.\n",
  },
  {
    id: "-5952315023526659624",
    parentId: "3317392024211927600",
    plantName: "Tomato",
    seedName: "Black Cherry",
    seedDescription:
      "\nBred in Florida by the late Vince Sapp, the round, 15-20 gm., fruits are almost black in color. The flavor is dynamic - much like an heirloom. High yielding. Indeterminate. Organically grown. Avg. 17,900 seeds/oz. Packet: 40 seeds.\n",
  },
  {
    id: "-2963023281309684469",
    parentId: "3317392024211927600",
    plantName: "Tomato",
    seedName: "Brandywine",
    seedDescription:
      '\nWe describe Brandywine\'s luscious, heirloom flavor as "very rich, loud, and distinctively spicy." The large fruits, often over 1 lb., have a deep pink skin and smooth red flesh. The medium-tall, potato-leaf plant is best staked or caged. Our "Quisenberry" strain is considered among the best. Indeterminate. Organically grown. Avg. 12,000 seeds/oz. Packet: 40 seeds.\n',
  },
  {
    id: "4443324153802806128",
    parentId: "3317392024211927600",
    plantName: "Tomato",
    seedName: "Cauralina",
    seedDescription:
      "\nThe exciting fourth introduction in Johnny's French Heritage tomato series. Matures early with heavy yields of 8-14 oz. beautiful, heart-shaped fruit. Improved disease resistance over true heirlooms of similar type. Possesses excellent eating quality that is uncommon among modern hybrid greenhouse tomatoes. Cauralina's fruit has a meaty texture with no gel, making it perfect for sauce, canning, and salsa; but it also has a full, rich flavor great for fresh eating. Produces a tall plant with wispy foliage. High resistance to fusarium wilt race 1, fusarium crown and root rot, and tomato mosaic virus. NOTES: 1) Prune to single leader. 2) Prune to 3-5 fruits per cluster, depending on desired fruit size. 3) Prune off the first flower, or \"king flower,\" to avoid producing abnormally large king fruit. Indeterminate. Avg. 206,200 seeds/lb. Packet: 15 seeds.\n",
  },
  {
    id: "4659584484197269102",
    parentId: "3317392024211927600",
    plantName: "Tomato",
    seedName: "Cherokee Purple",
    seedDescription:
      "\nFamously rich flavor and texture make this a colorful favorite among heirloom enthusiasts. Medium-large, flattened globe, 8-12 oz. fruits. Color is dusky pink with dark shoulders. Multilocular interior ranges from purple to brown to green. Relatively short vines. Indeterminate. Organically grown. Avg. 10,900 seeds/oz. Packet: 40 seeds.\n",
  },
  {
    id: "3774226052001340604",
    parentId: "3317392024211927600",
    plantName: "Tomato",
    seedName: "Chocolate Pear",
    seedDescription:
      "\nProduces 15-20 gm. fruits with unique color and pretty pear shape. Flavor is sweet and rich. Display with Yellow Pear or other specialty types for attractive mixed quarts. Indeterminate. Avg. 360,300 seeds/lb. Packet: 30 seeds.\n",
  },
  {
    id: "-5800393008136823400",
    parentId: "3317392024211927600",
    plantName: "Tomato",
    seedName: "Defiant PhR",
    seedDescription:
      "\nThis mid-size slicer has high resistance to late blight and intermediate resistance to early blight combined with great flavor. The 6-8 oz., globe-shaped fruit are smooth and medium-firm with good texture. Deep red internal and external color. High-yielding, medium-sized plants are widely adaptable. Defiant was traditionally bred to inherit the Ph-2 and Ph-3 major genes for late blight (Phytophthora) resistance. High resistance to fusarium wilt races 1, 2, late blight, and verticillium wilt; and intermediate resistance to early blight. Our thanks to North Carolina State University. for their cooperation. Determinate. Organically grown. Avg. 10,850 seeds/oz. Packet: 15 seeds.\n",
  },
  {
    id: "3363300486423262904",
    parentId: "3317392024211927600",
    plantName: "Tomato",
    seedName: "Juliet",
    seedDescription:
      '\nA larger sister variety of Santa, Juliet is one of the most disease resistant in our trials. Deep red, shiny fruits avg. 2-2 1/4" L x 1 3/8-1 1/2" W, weighing 1 1/2-2 oz. Typically 12-18 fruits per cluster. Delicious, rich tomato flavor for salads, great salsa, and fresh pasta sauce. Good crack resistance, vine storage, and shelf life. Intermediate resistance to early blight and late blight. AAS winner. Indeterminate. Avg. 10,400 seeds/oz. Packet: 15 seeds.\n',
  },
  {
    id: "2332981405902115240",
    parentId: "3317392024211927600",
    plantName: "Tomato",
    seedName: "New Girl",
    seedDescription:
      "\nFruits avg. 4-6 oz. and have better flavor and are more disease resistant than Early Girl. Widely adapted. High resistance to fusarium wilt races 1, 2 and verticillium wilt. Indeterminate. Select organic or conventional seeds. Organically grown. Avg. 12,000 seeds/oz. Packet: 40 seeds.\n",
  },
  {
    id: "-8615900873704222641",
    parentId: "3317392024211927600",
    plantName: "Tomato",
    seedName: "Striped German",
    seedDescription:
      "\nThe flat, medium to large, variably ribbed-shoulder tomatoes are shaded yellow and red. The marbled interior looks beautiful sliced. Complex, fruity flavor and smooth texture. Medium-tall vines bear 12+ oz. fruit. Indeterminate. Organically grown. Avg. 10,500 seeds/oz. Packet: 40 seeds.\n",
  },
  {
    id: "8748637458471043903",
    parentId: "3317392024211927600",
    plantName: "Tomato",
    seedName: "Sun Gold",
    seedDescription:
      "\nExceptionally sweet, bright tangerine-orange cherry tomatoes leave customers begging for more. Vigorous plants start yielding early and bear right through the season. Tendency to split precludes shipping, making these an exclusively fresh-market treat. The taste can't be beat. 15-20 gm. fruits. High resistance to fusarium wilt and tobacco mosaic virus. Indeterminate. Avg. 15,950 seeds/oz. Packet: 40 seeds.\n",
  },
  {
    id: "-6937118752126906180",
    parentId: "3317392024211927600",
    plantName: "Tomato",
    seedName: "Sunrise Sauce",
    seedDescription:
      "\nMuch sweeter flavor than others in its class. Sunrise Sauce produces high yields of 3-4 oz. squat, Roma-shaped fruits within a concentrated period, which makes it perfect for saucing. Not to mention it has exceptional fruit quality and flavor and cooks down quickly. The perfect patio tomato. High resistance to fusarium wilt race 1 and verticillium wilt. Determinate. Avg. 18,500 seeds/lb. Packet: 15 seeds.\n",
  },
  {
    id: "-7569094335649103441",
    parentId: "3317392024211927600",
    plantName: "Tomato",
    seedName: "Supersweet 100",
    seedDescription:
      "\nSupersweet 100 is a reliable cherry tomato with prolific yields of great tasting, 15-20 gm. fruits produced in large clusters. Widely adapted. High resistance to fusarium wilt and verticillium wilt. Indeterminate. Avg. 19,500 seeds/oz. Packet: 40 seeds.\n",
  },
  {
    id: "8406543660339281572",
    parentId: "3317392024211927600",
    plantName: "Tomato",
    seedName: "Valentine",
    seedDescription:
      "\nMassive early yields, deep red color, and unusually rich flavor. Developed in collaboration with Dr. Majid Foolad of Penn State University, Valentine marries the best of wild-type tomato genetics with flavorful high-performing strains. This vivid red, high-yielding, and early blight resistant tomato is the first commercial variety developed with Penn State's patented high-lycopene breeding lines. Excellent color contrast when mixed with Nova or Golden Sweet. Also adds diversity to a small tomato mix. Avg. fruit weight 12-14 gm. For best flavor, harvest when fruits are deep red. Long shelf life. AAS winner. U.S. Patent #8,524,992. Intermediate resistance to alternaria (early) blight. Indeterminate. Avg. 295,200 seeds/lb. Packet: 15 seeds.\n",
  },
  {
    id: "-3760057680900253892",
    parentId: "7243496257612484771",
    plantName: "Leek",
    seedName: "Bandit",
    seedDescription:
      "\nBandit has beautiful, very dark blue-green, erect leaves and good uniformity. The shank grows very thick with minimal bulbing. NOTE: For ease of sowing, Bandit's seed is coated with an inert, NOP-compliant film. Organically grown. Avg. 10,300 seeds/oz. Packet: 250 seeds.\n",
  },
  {
    id: "-3750064164607504753",
    parentId: "7243496257612484771",
    plantName: "Leek",
    seedName: "Gevaria",
    seedDescription:
      "\nGevaria has upright, attractive dark blue-green foliage. Long shanks are thick, straight, free of bulbing, and firm at any stage of maturity. Avg. 7,700 seeds/oz. Packet: 50 seeds.\n",
  },
  {
    id: "6848226199811845004",
    parentId: "7243496257612484771",
    plantName: "Leek",
    seedName: "King Richard",
    seedDescription:
      "\nBeautiful full-sized leeks. In favorable soil and culture, the white shank are over a foot long to the first leaf. Medium-green leaves with full habit. For baby leeks, plant closely (40 seeds/ft.) and harvest at finger size. While not hardy enough for overwintering, it will withstand medium-heavy frost (32° to 20°F/0° to -7°C) without losing its healthy appearance. Conventional plants are also available. Organically grown. Avg. 9,500 seeds/oz. Packet: 250 seeds.\n",
  },
  {
    id: "-6953659049788204003",
    parentId: "7243496257612484771",
    plantName: "Leek",
    seedName: "Lexton",
    seedDescription:
      "\nLexton has the long, thick shank of Megaton in a slower-growing, more cold-tolerant plant. Harvest well into very cold weather, after the early leeks are gone, in the afternoon during a thaw. Upright, healthy, dark blue-green foliage. Very little bulbing or splitting, easy to peel, with high yield potential. NOTE: We are not able to ship this item to Canada or California at this time. Avg. 9,000 seeds/oz. Packet: 50 seeds.\n",
  },
  {
    id: "329936421672082745",
    parentId: "7243496257612484771",
    plantName: "Leek",
    seedName: "Megaton",
    seedDescription:
      "\nUpright plants with beautiful blue-green foliage. Long, thick shanks have very high yield potential. Less bulbing and splitting, and easier to peel than open pollinated varieties. Vigorous and uniform. NOTE: We are not able to ship this item to Canada or California at this time. Organic seed is also available. Avg. 8.700 seeds/oz. Packet: 50 seeds.\n",
  },
  {
    id: "-5802147080242987372",
    parentId: "7243496257612484771",
    plantName: "Leek",
    seedName: "Pandora",
    seedDescription:
      "\nDark blue-green foliage. A late summer/early fall O.P. leek with a high percentage of usable shank with no bulbing. PLEASE NOTE: For ease of sowing, Pandora's seed is coated with an inert, NOP-compliant film. Organically grown. Avg. 10,700 seeds/oz. Packet: 250 seeds.\n",
  },
  {
    id: "-4133756544774271102",
    parentId: "7243496257612484771",
    plantName: "Leek",
    seedName: "Tadorna",
    seedDescription:
      "\nA vigorous grower producing a medium-length white shank and contrasting, very dark blue-green foliage. Holds in the field for fall into winter harvest, and overwinters in moderate climates. Moderate leaf disease resistance. Organic seed is also available. Avg. 9,600 seeds/oz. Packet: 250 seeds.\n",
  },
  {
    id: "6065549918599663050",
    parentId: "7243496257612484771",
    plantName: "Leek",
    seedName: "Takrima",
    seedDescription:
      "\nUpright, medium blue-green foliage with refined, bright white shanks. No bulbing and shelf blanching make Takrima a lower maintenance variety in the field and at harvest. Some heat tolerance. Avg. 9,200 seeds/oz. Packet: 50 seeds.\n",
  },
  {
    id: "6152968132247899176",
    parentId: "-8615932750481858489",
    plantName: "Celery",
    seedName: "Cutting Celery",
    seedDescription:
      "\nUse fresh in salads, cooked in soup, stew, and mixed vegetables. Also known as leaf celery. Select organic or conventional seeds. Avg. 68,800 seeds/oz. Packet: 200 seeds.\n",
  },
  {
    id: "5836884616659234677",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Crane Feather King White",
    seedDescription:
      '\nExtend the flower production season with ornamental kale. The Crane series is consistent, uniform, and provides a range of rich colors and textures for autumn bouquets. Crane Feather King White has light pink to creamy white centers surrounded by green outer leaves. Also known as flowering kale and ornamental cabbage. Ht. 24-36". Avg. 8,400 seeds/oz. Packet: 25 seeds.\n',
  },
  {
    id: "-4209593910255787000",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Crane Feather King White",
    seedDescription:
      '\nExtend the flower production season with ornamental kale. The Crane series is consistent, uniform, and provides a range of rich colors and textures for autumn bouquets. Crane Feather King White has light pink to creamy white centers surrounded by green outer leaves. Also known as flowering kale and ornamental cabbage. Ht. 24-36". Avg. 8,400 seeds/oz. Packet: 25 seeds.\n',
  },
  {
    id: "-5063385223258987670",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Crane Feather Queen Red",
    seedDescription:
      '\nExtend the flower production season with ornamental kale. The Crane series is consistent, uniform, and provides a range of rich colors and textures for autumn bouquets. Crane Feather Queen Red has bright magenta centers surrounded by green outer leaves. Also known as flowering kale and ornamental cabbage. Ht. 24-36". Avg. 7,700 seeds/oz. Packet: 25 seeds.\n',
  },
  {
    id: "3205766308424070840",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Crane Feather Queen Red",
    seedDescription:
      '\nExtend the flower production season with ornamental kale. The Crane series is consistent, uniform, and provides a range of rich colors and textures for autumn bouquets. Crane Feather Queen Red has bright magenta centers surrounded by green outer leaves. Also known as flowering kale and ornamental cabbage. Ht. 24-36". Avg. 7,700 seeds/oz. Packet: 25 seeds.\n',
  },
  {
    id: "-3383547134323550382",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Crane Pink",
    seedDescription:
      '\nExtend the flower production season with ornamental kale. The Crane series is consistent, uniform, and provides a range of colors. Crane Pink has bright pink centers surrounded by green outer leaves. Also known as flowering kale and ornamental cabbage. Ht. 24-36". Avg. 9,000 seeds/oz. Packet: 50 seeds.\n',
  },
  {
    id: "-6876427806568426914",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Crane Pink",
    seedDescription:
      '\nExtend the flower production season with ornamental kale. The Crane series is consistent, uniform, and provides a range of colors. Crane Pink has bright pink centers surrounded by green outer leaves. Also known as flowering kale and ornamental cabbage. Ht. 24-36". Avg. 9,000 seeds/oz. Packet: 50 seeds.\n',
  },
  {
    id: "9016300158126669192",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Crane Red",
    seedDescription:
      '\nExtend the flower production season with ornamental kale. The Crane series is consistent, uniform, and provides a range of colors. Crane Red has plum centers surrounded by dark green-to-purple outer leaves. Also known as flowering kale and ornamental cabbage. Ht. 24-36". Avg. 8,600 seeds/oz. Packet: 50 seeds.\n',
  },
  {
    id: "-68584087601298426",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Crane Red",
    seedDescription:
      '\nExtend the flower production season with ornamental kale. The Crane series is consistent, uniform, and provides a range of colors. Crane Red has plum centers surrounded by dark green-to-purple outer leaves. Also known as flowering kale and ornamental cabbage. Ht. 24-36". Avg. 8,600 seeds/oz. Packet: 50 seeds.\n',
  },
  {
    id: "-7215540927542016235",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Crane White",
    seedDescription:
      '\nExtend the flower production season with ornamental kale. The Crane series is consistent, uniform, and provides a range of colors. Crane White has creamy white centers with a blush of pink surrounded by green outer leaves. Also know as flowering kale and ornamental cabbage. Ht. 24-36". Avg. 9,600 seeds/oz. Packet: 50 seeds.\n',
  },
  {
    id: "-676953290466857680",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Crane White",
    seedDescription:
      '\nExtend the flower production season with ornamental kale. The Crane series is consistent, uniform, and provides a range of colors. Crane White has creamy white centers with a blush of pink surrounded by green outer leaves. Also know as flowering kale and ornamental cabbage. Ht. 24-36". Avg. 9,600 seeds/oz. Packet: 50 seeds.\n',
  },
  {
    id: "1492910917116592166",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Sunrise",
    seedDescription:
      '\nFlorists love these small-headed, leaf-type cabbages. They will grow successfully wherever temperatures become sufficiently cool. Very long vase life. Also known as flowering kale and ornamental cabbage. Ht. 24-36". Avg. 9,200 seeds/oz. Packet: 50 seeds.\n',
  },
  {
    id: "-6738507062875087439",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Sunrise",
    seedDescription:
      '\nFlorists love these small-headed, leaf-type cabbages. They will grow successfully wherever temperatures become sufficiently cool. Very long vase life. Also known as flowering kale and ornamental cabbage. Ht. 24-36". Avg. 9,200 seeds/oz. Packet: 50 seeds.\n',
  },
  {
    id: "1775822460712634636",
    parentId: "-7234723121193579423",
    plantName: "Broccoli",
    seedName: "Sunset",
    seedDescription:
      '\nFlorists love these small-headed, leaf-type cabbages. They will grow successfully wherever temperatures become sufficiently cool. Very long vase life. Also known as flowering kale and ornamental cabbage. Ht. 24-36". Avg. 9,800 seeds/oz. Packet: 50 seeds.\n',
  },
  {
    id: "1697741427628751377",
    parentId: "-2882781183424417388",
    plantName: "Cauliflower",
    seedName: "Sunset",
    seedDescription:
      '\nFlorists love these small-headed, leaf-type cabbages. They will grow successfully wherever temperatures become sufficiently cool. Very long vase life. Also known as flowering kale and ornamental cabbage. Ht. 24-36". Avg. 9,800 seeds/oz. Packet: 50 seeds.\n',
  },
  {
    id: "8409749895256991466",
    parentId: "8966395072127027946",
    plantName: "Carrot",
    seedName: "Dara",
    seedDescription:
      '\nAttractive 3-5" lacy umbels atop strong, sturdy, upright stems. Flowers in shades of dark purple, pink, or white. Highly productive with 7-15 stems per plant. Long-lasting in bouquets. Also known as Queen Anne\'s lace, ornamental carrot, and wild carrot. Ht. 36-50". Avg. 31,100 seeds/oz. Packet: 100 seeds.\n',
  },
  {
    id: "1585854929816902080",
    parentId: "-1452327664920181626",
    plantName: "Pepper",
    seedName: "Pretty in Purple",
    seedDescription:
      '\nLeaves of these spreading but upright plants are solid purple or variegated purple and green. The 3/4", rounded, glossy, deep purple peppers ripen to yellow, orange, and finally scarlet. The pungent fruits may be used as a hot pepper seasoning. Ht. 18-24". Avg. 6,300 seeds/oz. Packet: 30 seeds.\n',
  },
]);
const customStore = {
  subscribe: seeds.subscribe,
  setSeeds: (items) => {
    seeds.set(items);
  },
};

export default customStore;
